import LocalizedStrings from 'react-localization'
import { TRIAL_INCLUDED_CREDITS } from './constants/plans'

let strings = new LocalizedStrings({
  en: {
    /* Place global strings */
    CREATE: 'Create',
    RESET: 'Reset',
    CLOSE: 'Close',
    ADD: 'Add',
    SUBMIT: 'Submit',
    CANCEL: 'CANCEL',
    CONFIRM: 'Confirm',
    DETAILS: 'Details',
    VALUE: 'Value',
    OFFLINE: 'Offline',
    ONLINE: 'Online',
    FILING_LIST: 'Filing List',
    DOCUMENT_LIST: 'Document List',
    OR: 'OR',
    ERROR: 'error',
    LOADING: 'Loading',
    UPDATE: 'Update',
    MANAGE: "Manage",
    BUSINESS: 'Business',
    OWNER: 'Owner',
    DEBTOR: 'Debtor',
    AUTHORIZING_PARTY: 'Authorizing Party',
    CLIENT: 'Client',
    CUSTOMER: 'Customer',
    USER: 'User',
    USERS: 'Users',
    EDIT: 'Edit',
    DELETE: 'Delete',
    VIEW: 'View',
    APPLY: 'Apply',
    FILTERS: 'Filters',
    HIDDEN: 'Hidden',
    COLUMNS: 'Columns',
    DOWNLOAD_PDF: 'Download PDF',
    DOWNLOAD_IMAGE: 'Download Image',
    DOWNLOAD_DOCUMENT: 'Download Document',
    ATTACH: 'Attach',
    ATTACH_PDF: 'Attach PDF',
    ATTACH_ITEMS: 'Attach Items',
    ORIGINAL_FILINGS: 'Original Filings',
    DOCUMENT_REQUEST_CONFIRMATION: 'Document Request Confirmation',
    UCC: 'UCC',
    FILING: 'Filing',
    FILINGS: 'Filings',
    NAME: 'Name',
    TITLE: 'Title',
    SEARCH: 'Search',
    SELECT: 'Select',
    Save: 'Save',
    SAVED: 'Saved',
    LOGIN: 'Login',
    VIEW_MORE: 'View more',
    PERFORM: 'Perform',
    ATTACHMENTS: 'Attachments',
    SAVED_SEARCH_REPORTS: "Saved Search Reports",
    BUSINESS_INFORMATION: 'Business Information',
    DEBTOR_INFORMATION: 'Debtor Information',
    SECURED_INFORMATION: 'Secured Party Information',
    CREDITOR_INFORMATION: 'Creditor Information',
    OFFENSES_INFORMATION: 'Offenses Information',
    ADD_OWNER: 'Add Owner',
    ADD_USER: 'Add User',
    ADD_DEBTOR: 'Add Debtor',
    ADD_SECURED_PARTY: 'Add Secured Party',
    ADD_CUSTOMER: 'Add Customer',
    CREATE_APPLICATION: 'Create application',
    CREATE_APPLICATION_MANUALLY: 'Create Application Manually',
    PROFILE_REDIRECT: 'Profile',
    SETTINGS: 'Settings',
    CUSTOMER_PROFILE: 'Customer Profile',
    PROFILE: 'Profile',
    PROFILE_FORM: 'Profile Form',
    PROFILE_NOTIFICATIONS: {
      TAB: 'Notifications',
      TITLE: 'Monitoring alerts',
      MONITORING_ALERTS: 'Get monitoring alerts',
      ON_HINT: "You get email and in-app alerts for the businesses where you turned on Notify me. Turn this off to pause all of them; your choices are kept.",
      ON_HINT_EMAIL_ONLY: "You get email alerts for the businesses where you turned on Notify me. Turn this off to pause all of them; your choices are kept.",
      OFF_HINT: "Paused: you won't get any monitoring alerts, even from your team's recipient list. Turn this back on to get the same alerts as before.",
      PAUSED: 'Monitoring alerts paused.',
      RESUMED: 'Monitoring alerts turned back on.',
    },
    PROFILE_SIGNATURE: {
      TAB: 'Signature',
      TITLE: 'Credit memo signature',
      DESCRIPTION: 'This is how your signature appears on credit memos you approve. Changing it doesn\'t change memos you already signed.',
      MARK: 'Signature',
      MARK_TYPED: 'Typed',
      MARK_TYPED_HELP: 'Your account name in a signature style.',
      MARK_DRAWN: 'Drawn',
      MARK_DRAWN_HELP: 'Draw it with your mouse, trackpad or finger.',
      STAMP: 'Stamp',
      STAMP_PLAIN: 'Plain',
      STAMP_PLAIN_HELP: 'Signature over a line.',
      STAMP_STAMP: 'Stamp',
      STAMP_STAMP_HELP: 'Signature inside an approval stamp.',
      STAMP_SEAL: 'Stamp with seal',
      STAMP_SEAL_HELP: 'Signature beside an approval seal.',
      DRAW_HINT: 'Sign inside the box.',
      CLEAR: 'Clear',
      DRAW_AGAIN: 'Draw again',
      PREVIEW: 'Preview',
      PREVIEW_ROLE: 'Credit memo approver',
      SAVE: 'Save signature',
      RESET: 'Use default',
      SAVED_TOAST: 'Signature saved.',
      RESET_TOAST: 'Signature reset to the default.',
      DRAW_REQUIRED: 'Draw your signature before saving.',
      LOAD_ERROR: 'Your signature settings could not be loaded.',
      RETRY: 'Retry',
      DEFAULT_NOTE: 'You are using the default signature.',
      APPROVE_PREVIEW: 'Your signature',
      APPROVE_CHANGE: 'Change signature'
    },
    PASSWORD_CHANGE_FORM: 'Password Change Form',
    LOG_OUT: 'Log Out',
    ERROR_BOUNDRY_HEADER: 'We ran into a problem.',
    ERROR_BOUNDRY_BODY: 'Try to refresh your browser or use your browser back button to go back to the previous page.',
    INFO_NO_CLIENT_REFERENCE: 'requires a Client Reference configured before doing UCC operations, please go back and open the edit business dialog and enter a Client Reference.',
    INFO_ENTER_CLIENT_REFERENCE: 'requires a Client Reference configured, please enter a Client Reference',
    INFO_FILING_VIEW: 'Debtor and Secured Party details shown here are considering the Party Amendments done to this Filing. For details on other types of Amendments please check the Amendment List at the bottom of this Filing.',
    INFO_FILING_REQUEST: 'Remember that Offline Documents will be sent to your configured FCS email address.',
    DOCUMENT_VIEW: 'Document View',
    DOCUMENT_REQUEST_LOADING: 'Please wait while we receive the documents...',
    ROX_ADMIN: 'ROX_ADMIN',
    CONFIRM_ARCHIVE: 'Yes, Archive',
    CUSTOMER_ADMIN: 'CUSTOMER_ADMIN',
    CHANGE_PASSWORD: 'Change Password',
    AUTHORIZATION: 'Authorization',
    ALLOWED_TO_OPERATE: 'Allowed To Operate',
    LAST_DATA_RETRIEVAL: 'Last Data Retrieval: ',
    NO_DOT_WARNING: 'Add a DOT Number to the Business Information to be able to request FMCSA Data',
    FMCSA_VERIFICATION: 'FMCSA Verification',
    MOTUS_VERIFICATION: 'MOTUS Verification',
    EXTENSIVE_FMCSA_SEARCHES: 'Extensive FMCSA Searches',
    REQUEST_FMCSA_DATA: 'Request FMCSA data',
    FMCSA_DETAILS: 'FMCSA Details',
    FMCSA_REPORT: 'FMCSA Report',
    SEARCH_REPORT: 'Search Report',
    EMAIL_LOGS: 'Email Logs',
    EMAIL_LOG_ENTRIES: 'Email Log Entries',
    SOMETHING_WENT_WRONG: "Internal Server Error. Please try again or contact Support",
    SUCCESS: 'Success',
    SUCCESSFULL: 'Successful',
    UNSUCCESSFULL: 'UNSUCCESSFUL',
    PREVIEW: 'Preview',
    NO_RECORDS_FOUND: 'No Records Found!',
    DOWNLOAD_REPORT: 'Download Report',
    GENERATE_NEW_REPORT: 'Generate new report',
    DOWNLOAD_AS_PDF: 'Download as PDF',
    ATTACH_REPORT: 'Attach Report',
    COLLATERAL: 'Collateral',
    APPLICATION: 'Application',
    APPLICATIONS: 'Applications',
    CLEAR_FILTERS: 'Clear filters',
    APPLICATIONS_LEDE: 'Everything in the pipeline. Open a row to see its diligence and memo.',
    GET_REPORT: 'Get Report',
    CONFIRM_DELETE: 'Confirm Delete',
    REPORT_GENERATED: 'Report was generated correctly',
    REPORT_SUCCESS_MSG: 'Report was generated and added to attachments',
    UPLOAD_FILE: 'Upload File',
    DOWNLOAD_WILL_START_SOON: 'Download will start soon.',
    BROKER_DASHBOARD: {
      PAGE_TITLE: 'Broker dashboard',
      DATE_RANGE_LABEL: 'Date range',
      SELECT_BROKERS_LABEL: 'Select brokers',
      ALL_BROKERS: 'All Brokers',
      BROKERS_SELECTED: 'Broker(s) Selected',
      SEARCH_BROKERS_PLACEHOLDER: 'Search brokers...',
      LAST_30_DAYS: 'Last 30 days',
      LAST_60_DAYS: 'Last 60 days',
      LAST_90_DAYS: 'Last 90 days',
      TOTAL_SUBMISSIONS: 'Total Submissions',
      APPROVAL_RATE: 'Approval Rate',
      AVG_PIPELINE_VELOCITY: 'Avg. Pipeline Velocity',
      IN_PROGRESS: 'In Progress',
      DAYS: 'Days',
      APPLICATION_STATUS_FUNNEL: 'Application status funnel',
      SUBMISSIONS_PER_DAY: 'Submissions per day',
      RECENT_APPLICATION_ACTIVITY: 'Recent application activity',
      APPLICATION_NAME: 'Application Name',
      STATUS: 'Status',
      SUBMITTED_DATE_TIME: 'Submitted Date & Time',
      TIME_IN_CURRENT_STAGE: 'Time in Current Stage',
      ACTION: 'Action',
      VIEW_DETAILS: 'View Details',
      FAILED_TO_LOAD: 'Failed to load dashboard data',
      NO_ACTIVITY_DATA: 'No activity data available',
      NO_RECENT_APPLICATIONS: 'No recent applications',
      SUBMITTED: 'Submitted',
      IN_PROGRESS_STATUS: 'In Progress',
      APPROVED: 'Approved',
      DENIED: 'Denied',
      SUBMISSIONS: 'Submissions'
    },
    WELCOME_TO_ROXWRITE:"Welcome to Roxwrite — You’re In!",
    CONFIRMATION_EMAIL_TEXT:"You're all set! Now you can streamline your underwriting process and accelerate approvals with ease.\n" +
        " Roxwrite brings applicants, documents, and decisions together in one powerful platform — so you can\n" +
        " move faster, stay organized, and grow your business.",
    PLEASE_CONFIRM_EMAIl:'Please Confirm Your Email',
    CONFIRM_EMAIL_TEXT:"To activate your account, check your inbox and click the confirmation link we just sent you. This helps us verify your identity and keep your account secure. Didn’t get the email? Be sure to check your spam or junk folder.",
    MONITORINGS: {
      NOTIFY_ME: "Notify me",
      NOTIFY_ME_ON: "You'll get alerts for this business.",
      NOTIFY_ME_OFF: "You won't get alerts for this business.",
      SET_UP_BY: "Monitoring requested by {name}",
      ALERTS_PAUSED: "Your monitoring alerts are paused.",
      ALERTS_PAUSED_LINK: "Turn them back on in your profile",
      TITLE: "Select Reports to be Monitored",
      ENABLED: "Enabled",
      DISABLED: "Disabled",
      FREQUENCY_LABEL: "Frequency",
      FREQUENCY_PLACEHOLDER: "Frequency",
      END_DATE_LABEL: "End Date",
      END_DATE_PLACEHOLDER: "End Date",
      CHOOSE_FREQUENCY: "Choose Frequency of Monitoring",
      ADDITIONAL_CHARGES: "Monitoring incurs additional report charges.",
      PROCEED: "Proceed",
      CANCEL: "Cancel",
      BACKGROUND_CHECK_OWNER: "Background Check Owner",
      BACKGROUND_CHECK: "Background Owner",
      VERIFICATION: "Verification",
      MONITORING: 'Monitoring',
      MONITORING_ALERTS: "Monitoring Alerts",
      START_END_MONITORING: "Start and End Monitoring",
      MONITORING_UPDATES: "Monitoring updates",
      COMING_SOON_TITLE: "Monitoring Coming Soon!",
      COMING_SOON_DESCRIPTION: "Stay ahead of risk with scheduled monitoring. When enabled, you’ll receive alerts on the day you’ve selected, notifying you of any updates that may impact your applicant’s risk profile.",
      COMING_SOON_FEATURE_1: "You'll be able to monitor the report of your choice.",
      COMING_SOON_FEATURE_2: "Reports will be automatically requested using your previous configuration on your selected monitoring day.",
      COMING_SOON_FEATURE_3: "New reports will be saved in the application’s attachments.",
      COMING_SOON_ALERTS_TITLE: "Alerts",
      COMING_SOON_TRACK_TITLE: "Here’s what monitoring will track:",
      COMING_SOON_FEEDBACK: "For feedback or feature requests email",
      COMING_SOON_FEEDBACK_EMAIL: "hello@roxwrite.com",
      MONITORING_ENABLED: "Monitoring enabled",      // <-- Added
      MONITORING_DISABLED: "Monitoring disabled"
    },
    ROLES: {
      ROX_ADMIN: 'ROX_ADMIN',
      UNDER_WRITER: 'UNDERWRITER',
      BROKER_CUSTOMER: 'BROKER_CUSTOMER'
    },
    STATUS_NAMES: {
      Unsuccessful: 'Unsuccessful',
      Successful: 'Successful',
      Hit_Completed: 'Hit & Completed',
      In_Progress: 'In-Progress',
      Soon_to_Lapse: 'Soon to Lapse',
      Queued: 'Queued',
      Not_Started: 'Not Started',
      Rejected: 'Rejected',
      Pending: 'Pending',
      Preparation: 'Preparation'
    },
    ROLE_NAMES: {
      CUSTOMER_ADMIN: 'Customer Admin',
      ROX_ADMIN: 'Rox Admin'
    },
    SETTINGS_FORM: {
      USER_EDIT_FORM: 'User Edit Form',
      USER_CREATE_FORM: 'User Create Form',
      USER_CREATE_TEMPLATE: 'User Create Template',
      SALES_REPRESENTATIVE: 'Sales Representatives',
      ADD_SALES_REPRESENTATIVE: 'Add Sales Representative',
      EDIT_SALES_REPRESENTATIVE: 'Edit Sales Representative',
      USER_FROM_SALES_REPRESENTATIVE: 'User From Sales Representative',
      DOCUSIGN_FORM: 'Docusign connection',
      TEMPLATE: {
        DESCRIPTION: 'Description',
        NAME: 'Name',
        SUCCESS_MSG: 'Template Created Successfully',
        COLLATERAL_DESCRIPTION_TEMPLATE: 'Collateral Description Template',
        ADD_TEMPLATE: 'Add Template'
      }
    },
    NOTIFICATION_FORM: {
      NOTIFICATION_SETTINGS: "Notification Settings",
      SAVE: "Save changes",
      SAVING: "Saving...",
      UCC_NOTIFICATIONS_ENABLED: "UCC Notifications Enabled",
      UCC_NOTIFICATIONS_DISABLED: "UCC Notifications Disabled",
      UCC_FILING_RECORDING_TAX_ENABLED: "UCC Filing Recording Tax Enabled",
      NOTIFICATION_SETTINGS_SAVED_SUCCESSFULLY: "Notification Settings Saved Successfully",
      OFF: "Off",
      EMAIL: "Email",
      NOTIFICATION_EMAIL: "Notification Email",
      NOTIFICATION_EMAIL_ASTERISK: "Notification Email *",
      UCC_NOTIFICATIONS_HINT: "When UCC notifications are on, this address gets an email whenever a UCC filing, amendment or continuation changes status (for example accepted or rejected by the state).",
      TASK_ASSIGNMENT_EMAILS: "Email task notifications",
      TASK_ASSIGNMENT_EMAILS_HINT: "When a task is assigned, rejected or completed, the person notified in the app also gets an email.",
    },
    LOGIN_STRING: {
      FORM_ERR_MSG: 'Please Enter your Username and/or Password.',
      API_ERR_MSG: 'Login Error! Incorrect Credentials.',
      FORGOT_PASSWORD: 'Forgot password?',
      READY_TO_ROXWRITE: `Let's get ready to rox!`,
      BACK_TO_LOGIN: 'Back to login',
      HINT: 'Enter the email address and we’ll send you the link to reset password',
      STRONG_PASSWORD: 'Password must contain',
      CHECK_INTERNET_CONNECTION: 'Please check your internet connection',
      OTP_LINK: 'Sign in with an email code',
      OTP_BACK_TO_PASSWORD: 'Sign in with password',
      OTP_EMAIL_HINT: "Enter your email and we'll send you a one-time sign-in code.",
      OTP_CODE_HINT: 'Enter the 8-character code we sent to your email.',
      OTP_CODE_SENT: "If the email is registered, we've sent you a code.",
      OTP_RESENT: 'We resent the code if it was still possible.',
      OTP_INVALID: 'Invalid code. Check it or request a new one.',
      OTP_EXPIRED: 'The code expired. Please request a new one.',
      OTP_EMAIL_INVALID: 'Please enter a valid email.',
      OTP_ERROR_GENERIC: "We couldn't process your request. Please try again.",
      OTP_CODE_REQUIRED: 'Please enter the code.',
      OTP_SEND_CODE: 'Send code',
      OTP_SEND_ME_CODE: 'Send me the code',
      OTP_VERIFY: 'Verify code',
      OTP_RESEND: 'Resend code',
      OTP_RESEND_IN: 'Resend code in',
      OTP_CHANGE_EMAIL: 'Change email',
      OTP_DEEPLINK_PROMPT: "We'll send a one-time sign-in code to",
      TWO_FACTOR_TITLE: 'Verify it is you',
      TWO_FACTOR_SENT: "We've sent a code to your email.",
      TWO_FACTOR_CHALLENGE_EXPIRED: 'Your sign-in attempt expired. Please enter your password again.',
      TWO_FACTOR_THROTTLED: 'Too many codes requested. Please wait a few minutes and try again.',
      TWO_FACTOR_DELIVERY_FAILED: "We couldn't send your code. Please try again in a moment.",
      TWO_FACTOR_PASSWORD_REQUIRED: 'This account signs in with a password. Enter your password to continue.',
      // Shown up-front on the code-only screens: 2FA accounts cannot finish this flow.
      OTP_TWO_FACTOR_NOTICE: 'If your organization requires two-factor authentication, sign in with your password instead — an email code alone will not let you in.',
      CREATE_PASSWORD_TITLE: 'Create your password',
      CREATE_PASSWORD_HINT: 'Your organization requires a password plus an email code. Create your password to continue.',
      CREATE_PASSWORD_CTA: 'Create password and sign in',
      CREATE_PASSWORD_INVALID: 'That password does not meet the requirements.',
      CREATE_PASSWORD_EXISTS: 'This account already has a password. Use "forgot my password" to change it.',
      REGISTER_TITLE: 'Verify your email',
      REGISTER_CODE_TITLE: 'Enter your code',
      REGISTER_EMAIL_HINT: "Enter your email and we'll send you a one-time code to get started. No password needed.",
      REGISTER_CODE_HINT: 'Enter the 8-character code we sent to your email.',
      REGISTER_CODE_SENT: "We've sent a code to your email.",
      REGISTER_SEND_CODE: 'Send me the code',
      REGISTER_VERIFY: 'Verify & continue',
      REGISTER_BACK_TO_LOGIN: 'Already have an account? Sign in',
      REGISTER_RATE_LIMIT: 'Too many registration attempts, please try again later.',
      REGISTER_DISABLED: 'Registration is not available right now. Please contact support.',
      // Complete-profile reminder (modal shown when /user/me status === "Pending")
      COMPLETE_TITLE: 'Complete your profile',
      COMPLETE_HINT: "Some details are temporary. Review them now or later from Settings.",
      COMPLETE_SECTION_PERSONAL: 'Personal',
      COMPLETE_SECTION_COMPANY: 'Company',
      COMPLETE_SECTION_SECURITY: 'Security',
      COMPLETE_FIRST_NAME: 'First name',
      COMPLETE_LAST_NAME: 'Last name',
      COMPLETE_PHONE: 'Phone',
      COMPLETE_COMPANY: 'Company name',
      COMPLETE_ADDRESS1: 'Address line 1',
      COMPLETE_ADDRESS2: 'Address line 2',
      COMPLETE_CITY: 'City',
      COMPLETE_STATE: 'State',
      COMPLETE_ZIP: 'ZIP',
      COMPLETE_COMPANY_PHONE: 'Company phone',
      COMPLETE_EIN: 'EIN',
      COMPLETE_WEBSITE: 'Website',
      COMPLETE_PASSWORD: 'Password',
      COMPLETE_PASSWORD_HINT: 'Set a password to also sign in with email + password. Leave empty to stay passwordless.',
      COMPLETE_NOW: 'Complete now',
      COMPLETE_LATER: 'Not now',
      COMPLETE_SUCCESS: 'Your profile is all set!',
      COMPLETE_ERROR: "We couldn't save your profile. Please try again.",
    },
    CUSTOMER_PROFILE_STRING: {
      CUSTOMER_NAME: 'Customer Name',
      CUSTOMER_BUSINESS_TYPE: 'Customer Business Type',
      CUSTOMER_EMAIL: 'Customer Email',
      CUSTOMER_PHONE: 'Customer Phone',
      NO_OF_USERS: 'Number of users',
      EDIT_PROFILE: 'Edit Profile'
    },
    CSV: {
      CSV_UPLOADS: 'CSV Uploads',
      NEW_CSV: 'Import New CSV ',
      RECENT_UPLOADS: 'Recent Uploads',
      CSV_FILES: 'CSV Files',
      UPLOAD_CSV_FILE: 'Upload CSV File',
      DRAG_AND_DROP: "Drag and Drop or Browse your CSV file",
      MAX_SIZE: 'Maximum file size must be less than 10MB and File type must be CSV',
    },
    DASHBOARD: {
      DASHBOARD: 'Dashboard',
      DASHBOARD_LEDE: 'Where the portfolio stands today: what changed, and what is open.',
      ALL_SOURCES: 'All sources',
      BY_STATUS: 'By status',
      TOTAL_VALUE: '{value} total value',
      VS_LAST_MONTH: 'vs last month',
      NO_VALUE_CLOSED: 'No value closed this month',
      CREATE_APPLICATION: 'Create application',
      PORTFOLIO_GROWTH: 'Portfolio growth',
      OPEN_APPLICATIONS: 'Open applications',
      APPLICATIONS_VALUE: 'Applications value',
      ROX_WRITE_OVERVIEW: 'RoxWrite overview',
      ROX_WRITE_GROWTH: 'RoxWrite growth',
      APPLICATIONS: 'Applications',
      PORTFOLIO_OVERVIEW: 'Portfolio overview',
      VIEW_ALL: 'View all',
      SHOW_LESS: 'Show less',
      FMCSA_HINT: 'MC, DOT and Name searches FMCSA for information.',
      SEARCH_FOR_BUSINESS: 'Search for business',
      NEW_APPLICATIONS: "New Applications",
      COMPLETED_APPLICATIONS: "Completed Applications",
      SAVE_DASHBOARD_FILTERS: 'Save filters',
      DASHBOARD_FILTERS_SAVED_SUCCESSFULLY: 'Dashboard Filters Saved Successfully',
      DEMO_MODE_APPLICATION_FAILED: 'Demo Mode Application Failed',
      CLEAR_SAVED_FILTERS: "Clear saved filters",
      DASHBOARD_FILTERS_CLEARED_SUCCESSFULLY: 'Dashboard filters have been cleared successfully',
    },
    LABEL: {
      UCC_FILED_DATE: 'UCC Filed Date',
      ORGANIZATION_NAME: 'Organization Name',
      LAST_NAME: 'Last Name',
      FIRST_NAME: 'First Name',
      MIDDLE_NAME: 'Middle Name',
      PHONE: 'Phone',
      EMAIL: 'Email',
      ADDRESS: 'Address',
      CITY: 'City',
      COUNTRY: 'Country',
      STATE: 'State',
      JURISDICTION_STATE: 'Jurisdiction State',
      US_STATE: 'US State',
      ZIP: 'Zip',
      USER_NAME: 'User Name',
      ROLES: 'Roles',
      CLIENT_ID: 'Client ID',
      TAX_ID: 'Tax ID',
    },
    APPLICANT: {
      DECISIONER: {
        REQUESTING_PULL_REPORTS: 'Requesting Reports',
        PULL_REPORT_REQUESTED: 'Reports Requested, Risk Determination Finished',
      },
      SUMMARY: {
        SUMMARY_TITLE: 'Summary',
        INSIGHTS_TITLE: 'Insights',
        OVERVIEW: 'Overview',
        NO_SUMMARY_DATA: 'No Summary Data',
        NO_INSIGHTS_DATA: 'No Insights Data',
        VIEW_MORE: 'View more',
        LAST_UPDATE: 'Last update',
        GET_DATA: 'Get data',
        GET_ALL_DATA: 'Get all data',
        NOT_RUN: 'Not run',
        PULLED: 'pulled',
        RUN_REPORTS: 'Run {count} reports',
        RUN_ONE_REPORT: 'Run 1 report',
        REPORTS_NOT_RUN: '{count} reports have not been run yet.',
        ONE_REPORT_NOT_RUN: '1 report has not been run yet.',
        GET_ALL_DATA_TEXT: 'Click get all data to get the latest information',
        ADD_DEBTOR: 'Add a Debtor to populate this section.',
        OWNERS_LIMIT: 'You’ve reached the limit, you can only add up to 5 owners',
        SOS_COMING_SOON: 'Automation for Secretary of State filings will be available soon. For now, ',
        SOS_COMING_SOON_LINK: 'click here to search for SOS filings.',
        SOS_FILINGS: 'SOS Filings',
        NO_RESULTS_YET: 'No results yet — try running a search by clicking "View more"',
        SECRETARY_OF_STATE: 'Secretary of State',
      },
      LIST_OF_APPLICATIONS: 'List of Applications',
      PROGRESS_APPLICANT: 'Progress Applicant',
      TERMINATE_BUTTON: 'Terminate',
      DETAIL_FILING_REPORT: 'Detail Filing Report',
      DETAIL_REPORT: 'Detail Report',
      INACTIVE_FILINGS: 'Include Inactive Filings',
      INCLUDE_INACTIVE_FILINGS: 'Includes Inactive Filings',
      SEARCH_PARAMETERS: 'Search Parameters',
      NEW_APPLICATION: 'New Application',
      SEARCH_FROM: 'Search from',
      SEARCH_BY_APPLICANT_NAME: 'Search applications',
      USE_BUSINESS_ADDRESS: 'Use Address from Business',
      USE_ADDRESS_STATE_AS_STATE_OF_FORMATION: 'Use Address State as State of Formation',
      ADDITIONAL_ADDRESSES: 'Additional Addresses',
      ARCHIVE_APPLICATION: 'Archive Application',
      CONFIRM_ARCHIVE: 'Are you sure you want to archive',
      YOU_CAN_UNARCHIVE: 'You can unarchive this application in the archive tab any time',
      SOS: {
        SAVE_RECORD_ERROR: 'Error saving record. Please try again.',
        AWAITING_RESPONSE: 'Waiting for results, it usually takes 2 minutes.',
        BUSINESS_NAME: 'Business Name',
        BUSINESS_INFORMATION: 'Business Information',
        DOCUMENT: 'Document',
        DOWNLOAD: 'Download',
        ENTITY_TYPE: 'Entity Type',
        FILE: 'File',
        FILING_DATE: 'Filing Date',
        FILING_DOCUMENT: 'Filing Document',
        FILING_HISTORY: 'Filing History',
        FILING_TYPE: 'Filing Type',
        NAME_HISTORY: 'Name History',
        NO_RESULTS_PREFIX: 'No results were found for "',
        NO_RESULTS_SUFFIX: '". Try your search again with different filters or a different search term.',
        NOT_THE_RIGHT_RESULT: 'Not the right result? View other options.',
        OPEN_SOS_WEBSITE: 'Open SOS Website',
        PERFORM_SOS_SEARCH: 'Perform SOS Search',
        PHYSICAL_ADDRESS: 'Physical Address',
        POSSIBLE_ALTERNATIVES_FOUND: 'Possible Alternatives Found',
        POSSIBLE_ALTERNATIVES: 'Possible Alternatives',
        SEARCH_HISTORY: 'Search History',
        RECORD_DETAILS: 'Record Details',
        RECORDS_FOUND: 'Records Found',
        REGISTERED_AGENT_INFORMATION: 'Registered Agent Information',
        REGISTERED_AGENT_NAME: 'Registered Agent Name',
        SAVE_RECORD: 'Save Record',
        RECORD_ALREADY_SAVED: 'Record Already Saved',
        APPLICATION_ALREADY_CREATED: 'Application Already Created',
        SAVED_RECORD_DETAILS: 'Saved Record Details',
        SAVED_RECORDS: 'Saved Records',
        SCREENSHOT_URL: 'Screenshot URL',
        MESSAGES: 'Messages',
        SEARCH_DATE: 'Search Date',
        SEARCH_ERROR: 'There was an error with the search, please try again.',
        RESEARCH: 'Research',
        SEARCH_RESULT: 'Search Result',
        SEARCH_RESULTS: 'Search Results',
        SEARCH_STATUS: 'Search Status',
        REQUESTED_BY: 'Requested By',
        SEARCHES: 'Searches',
        SOS: 'Secretary of State',
        LINKS: 'Links',
        STATE_OF_FORMATION: 'State of Formation',
        STATE_OF_SOS_REGISTRATION: 'State of SOS Registration',
        SOS_REGISTRATION: 'SOS Registration',
        STATE: 'State',
        STATUS: 'Status',
        TIMEOUT: 'This search is taking longer than expected, please come back later. Sorry for the inconvenience.',
        CONTINUE_WAITING: 'Continue Waiting',
        SOS_SEARCH: 'SOS Search',
        NO_PREVIOUS_SEARCHES: 'No Previous Searches',
        NO_RECORDS_SAVED: 'No Records Saved',
        CLOSE_MATCH: 'Close Match',
        VIEW_MORE: 'View more',
        BEST_MATCH: 'Best Match',
        ALTERNATIVE: 'Alternative',
        RELATED_BY_AGENT: 'Related By Agent',
        RELATED_BY_OFFICER: 'Related By Officer',
      },
      VERIFICATION: {
        VERIFICATION_REQUEST: 'Verification Request',
        VERIFICATION: 'Verification',
        VERIFICATION_DETAILS: 'Datasource Verification',
        VERIFICATION_LEGEND_MATCHED: 'Matched',
        VERIFICATION_LEGEND_NOT_CONFIRMED: 'Not confirmed',
        VERIFIED_BY_DATASOURCE: 'Matched against records',
        NOT_VERIFIED_BY_DATASOURCE: 'Not confirmed by datasource',
        NOT_RETURNED_BY_DATASOURCE: 'Not returned by datasource',
        PERFORM: 'Perform Verification',
        RISK_INDICATORS: 'Risk Indicators',
        FOLLOW_UP_ACTIONS: 'Follow-up Actions',
        CHRONOLOGY_HISTORY: 'Chronology History',
        WATCH_LISTS: 'Watch Lists',
        RISK_CODE: 'Risk Code',
        NAME: 'Name',
        ENTITY_NAME: 'Entity Name',
        PROGRAM: 'Program',
        COUNTRY: 'Country',
        AUTHORIZED_REPRESENTATIVES_VERIFICATIONS: 'Authorized Representatives Verifications',
        AUTHORIZED_REPRESENTATIVE: 'Authorized Representative',
        COMPANY: 'Company',
      },
      ACCESS_REQUEST: {
        SUPPORT_URL: 'https://support.roxwrite.com/hc/en-us/requests/new',
        LEXIS_TITLE: 'Please request access to Background (Lexis) via Support.',
        LEXIS_SUBJECT: 'Request Access - Background (Lexis)',
        LEXIS_DESCRIPTION_PREFIX: 'Client: ',
        LEXIS_DESCRIPTION_SUFFIX: 'Please enable Background (Lexis) access.',
        UCC_TITLE: 'Please request access to UCC (FCS) via Support.',
        UCC_SUBJECT: 'Request Access - UCC (FCS)',
        UCC_DESCRIPTION_PREFIX: 'Client: ',
        UCC_DESCRIPTION_SUFFIX: 'Please enable UCC (FCS) access.',
        OPEN_SUPPORT: 'Open Support Request'
      },
      UCC: {
        VIEW_DETAILS: 'View Details',
        TOTAL_PAGES: 'Total Pages',
        READY_TO_REQUEST: 'Ready to Request',
        SELECT_DOCUMENTS_TO_REQUEST: 'Select documents to request',
        OPEN_DOCUMENT: 'Open Document',
        PERFORM_UCC_SEARCH: 'Perform UCC Search',
        FILE_UCC: 'File Ucc',
        SEARCH_RESULTS: 'Search Results',
        ATTACHED_FILINGS: 'Attached Filings',
        PERFORM_SEARCH: 'Perform search to get details',
        UCC_SEARCH: 'UCC Search',
        INDEX_DATE: 'UCC Filings last updated on:',
        FILINGS: 'Filings',
        FILING_NUMBER: 'Filing Number',
        TERMINATION: 'Termination',
        TERMINATE_UCC: 'Terminate UCC',
        IRREVERSIBLE_ACTION_WARNING: 'This action is irreversible.',
        CONFIRM_TERMINATION_TEXT: 'Are you sure you’d like to terminate this UCC Filing?',
        TERMINATE_DOCUMENT: 'Terminate Document',
        FILING_TYPE: 'Filing Type',
        FILING_SELECTED: 'Filings Selected',
        REQUEST_DOCUMENTS: 'Request Documents',
        FILING_DATE: 'Filing Date',
        ACTION: 'Action',
        DOCUMENT: 'Document',
        SEARCH_TYPE: 'Search Type',
        SEARCH_DATE: 'Search Date',
        NO_PREVIOUS_SEARCHES_FOR_OWNER: 'There are no recent searches for this Owner.',
        NO_PREVIOUS_SEARCHES_FOR_BUSINESS: 'There are no recent searches for this Business.',
        NO_ATTACHED_FILINGS_FOR_OWNER: 'There are no attached filings for this Owner.',
        NO_ATTACHED_FILINGS_FOR_BUSINESS: 'There are no attached filings for this Business.',
        UCC_FILING_LAST_UPDATED_ON: 'UCC Filings last updated on',
        INCLUDE_INACTIVE_FILINGS: 'Include Inactive Filings',
        NUMBER_OF_FILINGS: 'Number of Filings',
        LAPSE_DATE: 'Lapse Date',
        DEBTORS: 'Debtors',
        SECUREDS: 'Secureds',
        AMENDMENTS: 'Amendments',
        GET_REPORT_DETAILS: 'Get Filing Details',
        GET_SEARCH_REPORT: 'Get Search Report',
        UCC_DOWNLOAD_MSG: 'UCC Document requested successfully',
        TOOLTIP1: 'Request and Download',
        TOOLTIP2: 'You’ve already requested document for this filing, please check in received documents or in attachments',
        UCC_HELP: 'UCC Search Guide',
        TOOLTIP3: 'Finish',
        TOOLTIP4: 'Re-open',
        UCC_SAVE_MSG: 'UCC search report has been saved',
        UCC_DELTE_MSG: 'UCC search report has been deleted',
        PDF_REPORT: 'Generate report',
        ALREADY_SAVED: 'You already saved this report, check the saved ones in UCC table.',
        DIRECT_AMENDMENTS: 'Direct Amendments',
        REQUEST_UCC_DOCUMENTS: 'Request UCC Documents',
        PARAMS_ERR_MSG: 'Error getting parameters for empty report',
        OFFLINE_DOCUMENTS_REQUEST_SUCCESS: 'Offline Documents Requested Successfully, Offline Documents will be delivered to your email address configured in FCS',
        DOCUMENTS_REQUEST_SUCCESS: 'Documents Requested Successfully',
        ALREADY_REQUESTED_OFFLINE_DOCUMENTS: 'Offline Documents already requested, documents will be delivered to your email address configured in FCS',
        ALREADY_REQUESTED_OFFLINE_DOCUMENT: 'This Offline Document was already requested, documents will be delivered to your email address configured in FCS',
        ALREADY_REQUESTED_ONLINE_DOCUMENT: 'This Document was already requested, documents will be delivered in about one minute to ROX. Please check later.',
        ERROR_IN_DOC: 'Error related to this document. Please contact Support indicating Application and Filing Number.',
        SECURED_PARTY_MASKING: 'Secured Party Masking',
        MASKING_MSG: 'When Secured Party Masking is enabled, First Corporate Services provides the secured party information.',
        NO_RESULTS_PREFIX: 'There were no results found for "',
        NO_RESULTS_SUFFIX: '". A Report is available for download.',
        NO_RESULTS: 'There were no results found',
        REQUEST_OFFLINE_DOCUMENTS: 'Request Offline Documents',
        REQUEST_ONLINE_DOCUMENTS: 'Download Online Documents',
        NO_ATTACHED_FILINGS: 'No Filings were selected. Search and Select the business or person associated to this application. If non of the results correspond to what you’re looking for, download a ',
        NO_RESULT_REPORT_LINK: 'no result report here',
        ALL_RESULTS_WERE_ATTACHED: 'All results were attached',
        SELECT_ALL: 'Select All',
        FILING_DETAIL_GENERATED_AND_ATTACHED_SUCCESSFULLY: 'Filing Details Report generated and attached successfully to the application',
        NO_RESULTS_REPORT_GENERATED_AND_ATTACHED_SUCCESSFULLY: 'No Results Report generated and attached successfully to the application',
        NO_RESULTS_REPORT_GENERATED_SUCCESSFULLY: 'No Results Report generated successfully',
        SORT_BY: 'Sort by',
        SHOW_ALL: 'Show All',
        MOST_RECENT: 'Most Recent',
        ACTIVE_FILINGS: 'Active Filings',
        STATUS: 'Status',
      },
      UCCFILING: {
        EDIT_AND_SUBMIT_AMENDMENT: 'Edit and Submit Amendment',
        JURISDICTION_INACTIVE: 'This Filing requires to confirm the Jurisdiction selected ',
        CONFIRM_JURISDICTION: 'Please confirm the Jurisdiction',
        CONFIRM_FILING_JURISDICTION: 'Please confirm the Filing Jurisdiction',
        FILER_REFRENCE: 'Filer Reference',
        CLIENT_REFRENCE: 'Client Reference',
        SELECT_AUTHORIZING_PARTY_HINT: 'Please select authorizing party',
        ENTER_SECURED_PARTY_DETAILS_HINT: 'Please enter Secured Party details',
        COLLATERAL_DESCRIPTION: 'Collateral Description',
        ONLY_TEXT: 'Only Text',
        ONLY_ATTACHMENTS: 'Only Attachments',
        TEXT_ATTACHMENTS: 'Text and Attachments',
        TEXT_HINT: 'Please enter collateral texts to the filing',
        ATT_HINT: 'Please select attachments to the filing',
        TEXT_ATT_HINT: 'Please enter collateral texts and select attachments to the filing',
        UCC_FILE_POSTING: 'UCC File Posting',
        UCC1_FILINGNUMBER: 'UCC1 Filing Number',
        LABEL: {
          COLLATERAL_DESCRIPTION: 'Collateral Description *',
          JURISDICTION_ID: 'Jurisdiction ID',
          DEMO_MODE_SIMULATE_RESPONSE: 'Simulate Response',

          DEMO_MODE_SIMULATE_LAPSE_DATE: 'Simulate Lapse Date',
          DEMO_MODE_SIMULATE_LAPSE_DATE_TOOLTIP: "To simulate a soon-to-expire or expiring filing, select a date within the next six months.",

          FILER_REFRENCE: 'Filer Reference',
          CLIENT_REFERENCE: 'Client Reference',
          SECURED_MASKING: 'Use Secured Party Representative Service from FCS',
          ORG_ID: 'Organization Id'
        },
        NOT_SELECED: '- Not Selected -',
        PREVIEW: 'UCC File Posting',
        SECURED_PARTY: 'Secured Party',
        FILE_POSTING: 'File Posting',
        FILING_IMAGE: 'Filing Image',
        AMENDMENT_HISTORY: 'Amendment History',
        REQUEST_FILING_IMAGE: 'Request Filing Image',
        PERFORM_UCC_AGAIN: 'Perform UCC Filing Again',
        ATTACHMENT: 'Attachment',
        MINIMUM_MSG: 'Select minimum 1 file to continue',
        JURISDICTION: 'Jurisdiction',
        FILING_DETAILS: 'Filing Details',
        FILING_NUMBER: 'Filing Number',
        TERMINATED: 'Terminated',
        TERMINATION_DATE: 'Termination Date',
        LAPSE_DATE: 'Lapse Date',
        LAST_UPDATE: 'Last Update',
        RETRY: 'Retry UCC Posting',
        ERROR_HEADING: 'Reasons reported:',
        PERFORM_SEARCH: 'Perform search to get details',
        STR_HINT: 'Search to Reflect (STR)',
        ADDITIONAL_INFO: 'Additional Information',
        TAX_ID: 'Tax ID',
        TAX_ID_WARNING: 'Tax ID is required for filings in ND or SD. Otherwise it will be ignored.',
        RECORDING_TAX_WARNING: 'Recording Tax is required for filings in TN.',
        RECORDING_TAX_TN_WARNING: 'If a consideration amount is listed as $0.00, an FCS team member will contact the client to provide proof of payment to be submitted with the filing',
        RECORDING_TAX_AL_WARNING: 'If a consideration amount is not provided, an FCS member will contact the client to provide proof of payment to be submitted with the filing',
        RECORDING_TAX_TN: 'Maximum principal indebtedness for Tennessee recording tax purposes is',
        RECORDING_TAX_AL: 'Maximum principal indebtedness for Alabama recording purposes is',
        RECORDING_TAX_LABEL: 'Recording Tax',
        RECORDING_TAX_NOTE: 'Recording Tax Note',
        RECORDING_TAX_ADDED_AS_COLLATERAL: 'will be added as collateral statement',
        RECORDING_TAX_TN_COLLATERAL: 'Maximum principal indebtedness for Tennessee recording tax purposes is',
        RECORDING_TAX_AL_COLLATERAL: 'Maximum principal indebtedness for Alabama recording purposes is',
        RECORDING_TAX_AL_EMPTY_COLLATERAL: 'Maximum principal indebtedness for Alabama recording tax purposes has been paid',
        IGNORED: 'ignored',
        STR: 'Search to Reflect',
        MASK: 'When Secured Party Masking is enabled, this information is provided by First Corporate Services after the filing is submitted',
        AMENDMENT_ACTION: 'Amendment Action',
        AMENDMENT_TYPE: 'Type',
        SS: 'Secretary of State',
        FIND_SS: 'Find Secretary of States',
        SS_HEADING: 'Choose the state where the corporation you are researching is registered.',
        REFRESH_FILING_DATA: 'Refresh Filing Data',
        ROX_ADVICE_TITLE: 'Rox Advice:',
        ROX_ADVICE_MESSAGE: 'The most common use is to file at the state level (no county). The only exception is for Georgia',
      },
      ATTACHMENTS: {
        GENERATING_CREDIT_MEMO: "Creating the credit memo – This should take about 30 seconds.",
        ADD_ATTACHMENTS: 'Add ATTACHMENTS',
        ATTACHMENTS: 'Attachments',
        UPLOAD_MSG: "File Uploaded Successfully",
        DELETE_MSG: "Deleted Successfully",
        DRAG_AND_DROP: "Drag and Drop or Browse your file",
        SUPPORTED_FILE: 'Supports size under 10MB',
        SUPPORTED_FILE_25MB: "Supports size under 25MB",
        ADD_COMMENTS: "Add Comments",
        MAX_SIZE: 'Maximum file size must be less than 10MB',
        MAX_FILES: 'Maximum five files can be selected',
        MAX_SUM_SIZE: 'Attachments should be lesser than 4MB of size per filings',
        PLUS_SYMBOL: '+',
        MINUS_SYMBOL: '-',
        GENERATE_CREDIT_MEMO: 'Generate Credit Memo',
      },
      CREDIT_CHECK: {
        CREDIT_CHECK: 'Credit Check',
        COMPANY_INFORMATION: 'Company Information',
        CURRENT_CREDIT_SCORE: 'Current Credit Score',
        COMPANY_CLASSIFICATION: 'Company Classification',
        BRANCHES: 'Branches',
        CONTACT_INFORMATION: 'Contact Information',
        PREVIOUS_CREDIT_SCORE: 'Previous Credit Score',
        PAYMENT_SUMMARY: 'Payment Summary',
        FILING_SUMMARY: 'Filing Summary',
        TRADE_LINES_INFORMATION: 'Trade Lines Information',
        TRADE_PAYMENTS_BY_CREDIT: 'Trade Payments By Credit',
        LIFE_TIME_HIGH_BALANCE: 'Life Time High Balance',
        CREDIT_RATING_HISTORY: 'Credit Rating History',
        MONTHLY_BALANCE_HISTORY: 'Monthly Balance History',
        DBT_HISTORY: 'DBT History',
        RAW_DATA: 'Raw Data'
      },
      CREDIT_MEMO: {
        CREDIT_MEMO_REPORT: 'Credit Memo Report',
        COMPREHENSIVE_RISK_ASSESSMENT: 'Comprehensive risk assessment and background verification analysis',
        GENERATED: 'Generated',
        REPUTATION_FLAGS: 'Reputation Flags',
        RISK_ASSESSMENT_INSIGHTS: 'Risk Assessment Insights',
        DETAILED_FINDINGS: 'Detailed findings from FMCSA and background check data',
        PRIMARY_RISK_CATEGORIES: 'Primary Risk Categories',
        ADDITIONAL_RISK_FACTORS: 'Additional Risk Factors',
        CRITICAL_FINDINGS: 'Critical Findings',
        POSITIVE_FACTORS: 'Positive Factors',
        EXECUTIVE_SUMMARY: 'Executive Summary',
        COMPREHENSIVE_ANALYSIS: 'Comprehensive analysis and recommendations',
        OVERALL_ASSESSMENT: 'Overall Assessment',
        REQUEST_CREDIT_MEMO: 'Request Credit Memo',
        REQUESTING_CREDIT_MEMO: 'Requesting...',
        NO_REPORTS_SAVED: 'Save at least one report before requesting a credit memo.',
        CREDIT_MEMO_REQUEST_SUCCESS: 'Credit memo request submitted successfully. Generating report...',
        CREDIT_MEMO_REQUEST_ERROR: 'Failed to request credit memo. Please try again later.',
        CREDIT_MEMO_REQUEST_WARNING: 'Unable to connect to credit memo service. Showing demo data instead.',
        GENERATE_DESCRIPTION: 'Generate a comprehensive credit memo report with risk assessment insights, background verification analysis, and executive summary for this applicant.',
        PROCESSING_DESCRIPTION: 'Please wait while we generate your comprehensive credit memo report. This may take a few moments...',
        // Status labels
        TIN_UNVERIFIED: 'TIN Unverified',
        PHONE_DETAILS_MISSING: 'Phone Details Missing',
        NO_WATCHLIST_ENTRIES: 'No Watchlist Entries',
        NO_BANKRUPTCIES: 'No Bankruptcies',
        // KPI labels
        RISK_SCORE: 'Risk Score',
        MODERATE_RISK_PROFILE: 'Moderate Risk Profile',
        ACTIVE_LIENS: 'Active Liens',
        LIENS_JUDGEMENTS_RECORDED: 'Liens & Judgements Recorded',
        UCC_FILINGS: 'UCC Filings',
        MAJORITY_ACTIVE: 'Majority Active',
        KANSAS_UCC_FILINGS: 'Kansas UCC-1 Filings',
        BANKRUPTCIES: 'Bankruptcies',
        NO_FINANCIAL_DISTRESS: 'No Financial Distress',
        HIGH: 'High',
        NONE: 'None',
        // Entity information labels
        DATE_ESTABLISHED: 'Date Established',
        ENTITY_TYPE: 'Entity Type',
        PRIMARY_LOCATION: 'Primary Location',
        BUSINESS_NATURE: 'Business Nature',
        // Risk assessment labels
        SOS_FILINGS: 'SOS Filings',
        FMCSA: 'FMCSA',
        BUSINESS_VERIFICATION: 'Business Verification',
        BUSINESS_BACKGROUND_CHECK: 'Business Background Check',
        OWNER_BACKGROUND_CHECK: 'Owner Background Check',
        WATCH_LIST: 'Watch List',
        LIENS: 'Liens',
        CRIMINAL_HISTORY: 'Criminal History',
        SAFETY_RATING: 'Safety Rating',
        INSURANCE: 'Insurance',
        // Status descriptions
        ACTIVE: 'Active',
        SATISFACTORY: 'Satisfactory',
        MEDIUM_RISK: 'Medium Risk',
        LOW_RISK: 'Low Risk',
        NO_HITS: 'No Hits',
        NO_LIENS: 'No Liens',
        FILINGS_COUNT: 'Filings',
        LIENS_FOUND: 'Liens Found',
        CRIMINAL_RECORDS: 'Criminal Records',
        // Edit labels
        EDIT: 'Edit',
        SAVE: 'Save',
        CANCEL_EDIT: 'Cancel',
        PARAGRAPH_1: 'Paragraph 1',
        PARAGRAPH_2: 'Paragraph 2',
        PARAGRAPH_3: 'Paragraph 3',
        LOAD_ERROR: 'The credit memo could not be loaded.',
        APPROVAL: {
          TITLE: 'Approval',
          STATE_DRAFT: 'Draft',
          STATE_IN_APPROVAL: 'In approval',
          STATE_SIGNED: 'Signed',
          STATE_APPROVED: 'Approved',
          STATE_RETURNED: 'Rejected',
          STATE_WITHDRAWN: 'Withdrawn',
          DRAFT_DESCRIPTION: 'This credit memo has not been sent for approval.',
          REQUEST_APPROVAL: 'Request approval',
          REQUEST_TITLE: 'Request approval',
          REQUEST_BODY: 'Choose who should review this credit memo. Only the people you choose are notified. Everyone you choose must sign it, and any one of them can reject it. Once everyone has signed, you or any of them can approve it.',
          ALL_MUST_SIGN: (count) => count > 1 ? `All ${count} must sign` : null,
          SIGNATURES_PROGRESS: (signed, required) => `${signed} of ${required} signatures`,
          SIGNER_YOU: (name) => `${name} (you)`,
          SIGNER_SIGNED: (date) => `Signed ${date}`,
          SIGNER_WAITING: 'Waiting to sign',
          SIGNATURES_SET_ASIDE: (names) => `${names} had already signed. If the memo is sent again, everyone signs again.`,
          SIGNED_TOAST: (remaining) => `Signed. Waiting for ${remaining} more ${remaining === 1 ? 'signature' : 'signatures'}.`,
          ALL_SIGNED_TOAST: 'Signed. All signatures are in, so the memo is ready to approve.',
          ALL_SIGNED: (count) => count === 1 ? 'The signature is in. Ready to approve.' : `All ${count} signatures are in. Ready to approve.`,
          READY_FOR_YOU: 'Approve it to create the signed PDF and save it to Attachments.',
          READY_TO_APPROVE: 'The requester or any of the approvers can now approve it, which creates the signed PDF.',
          APPROVED_ON_BY: (name, date) => `Approved by ${name} on ${date}.`,
          FINALIZE: 'Approve',
          FINALIZE_TITLE: (version) => `Approve version ${version}`,
          FINALIZE_BODY: (count) => `${count === 1 ? 'The approver has' : `All ${count} approvers have`} signed. Approving creates the signed PDF with ${count === 1 ? 'their signature' : 'every signature'} and saves it to the application's Attachments.`,
          FINALIZE_CONFIRM: 'Approve',
          STATUS_PROMPT_TITLE: 'Approve the application too?',
          STATUS_PROMPT_BODY: (status) => `The credit memo is approved. Do you also want to change the application status from ${status} to Approved?`,
          STATUS_PROMPT_BODY_NO_STATUS: 'The credit memo is approved. Do you also want to change the application status to Approved?',
          STATUS_PROMPT_KEEP: 'Not now',
          STATUS_PROMPT_CONFIRM: 'Approve application',
          SELECT_ALL: 'Select all',
          SELECT_ALL_SHOWN: (count) => `Select all ${count} shown`,
          SEARCH_APPROVERS: 'Search by name or email',
          NO_APPROVER_MATCH: 'No approvers match your search.',
          APPROVERS_SELECTED: (count) => `${count} ${count === 1 ? 'approver' : 'approvers'} selected`,
          CLEAR_SELECTION: 'Clear',
          SEND_REQUEST: (count) => count ? `Send to ${count} ${count === 1 ? 'approver' : 'approvers'}` : 'Send request',
          WAITING_FOR: (names, count) => count > 1
            ? `Waiting for one of ${names} to sign or reject it.`
            : `Waiting for ${names} to sign or reject it.`,
          REQUESTED_BY_YOU: (date) => `You requested approval on ${date}.`,
          WAITING_FOR_YOU: 'Waiting for you to sign or reject it.',
          WAITING_FOR_YOU_OR: (names, count) => count > 1
            ? `Waiting for you or one of ${names} to sign or reject it.`
            : `Waiting for you or ${names} to sign or reject it.`,
          VIEW_MEMO_PDF: 'View PDF',
          WAITING_LOCKED: 'The memo can\'t be edited until then, or until the request is withdrawn.',
          NO_APPROVERS: 'Nobody else can approve credit memos for this client. Ask your admin to make someone a credit memo approver.',
          MEMO_NOT_READY: 'The credit memo must finish generating before it can be sent for approval.',
          REQUESTED_BY: (name, date) => `Approval requested by ${name} on ${date}.`,
          WAITING: 'Waiting for an approver. The memo can\'t be edited until it is approved, rejected or withdrawn.',
          RETURNED_BY: (name, date) => `Rejected by ${name} on ${date}:`,
          APPROVE: 'Sign',
          RETURN: 'Reject',
          WITHDRAW: 'Withdraw request',
          VIEW_SIGNED: 'View signed PDF',
          VIEW_PDF: 'View',
          PREVIEW_PDF: 'Preview PDF',
          APPROVE_TITLE: (version) => `Sign version ${version}`,
          APPROVE_BODY: (name) => `You are signing as ${name}. Your name, the time and a signature ID will be stamped on the signed PDF, which is created when the requester approves the memo.`,
          ATTEST: 'I reviewed this credit memo and approve it.',
          APPROVE_CONFIRM: 'Sign',
          RETURN_TITLE: (version) => `Reject version ${version}`,
          RETURN_BODY: 'Tell the requester why you are rejecting it. They will see your comment.',
          RETURN_COMMENT: 'Comment',
          RETURN_CONFIRM: 'Reject memo',
          CANCEL: 'Cancel',
          HISTORY: (count) => `Version history (${count})`,
          VERSION: (number) => `Version ${number}`,
          HISTORY_REQUESTED: (name, date) => `Requested by ${name} on ${date}`,
          HISTORY_DECIDED: (name, date) => `${name} · ${date}`,
          SUPERSEDED: 'Replaced by a later edit',
          LOAD_ERROR: 'Approval details could not be loaded.',
          RETRY: 'Retry',
          REQUESTED_TOAST: 'Approval requested. Approvers have been notified.',
          APPROVED_TOAST: 'Credit memo approved. The signed PDF is in Attachments.',
          RETURNED_TOAST: 'Credit memo rejected. The requester has been notified.',
          WITHDRAWN_TOAST: 'Approval request withdrawn.',
          LOCKED_TOOLTIP: 'Waiting for approval. Withdraw the request to edit.',
          USER_APPROVER: 'Credit memo approver',
          USER_PERMISSIONS: 'Permissions',
          USER_APPROVER_BY_ROLE_HELP: 'Included in this user\'s role. Change the role to remove it.',
          USER_APPROVER_HELP: 'Can approve and sign credit memos.'
        }
      },
      REPUTATION_REPORT: {
        // Roxy's nine authored states, written out — the panel status line
        // repeats the state in words so motion is never the only signal.
        ROXY: {
          IDLE: 'Ready',
          GREETING: 'Hi there',
          LISTENING: 'Listening',
          THINKING: 'Thinking',
          SPEAKING: 'Answering',
          WORKING: 'Working on it',
          SUCCESS: 'Done',
          ALERT: 'Needs attention',
          HANDOFF: 'Handing off',
        },
        PUBLIC_REPUTATIONAL_REPORT: 'Public Reputational Report',
        COMPREHENSIVE_VERIFICATION_ANALYSIS: 'Comprehensive verification and reputation analysis',
        REGULATORY_COMPLIANCE: 'REGULATORY COMPLIANCE',
        PUBLIC_REPUTATION: 'PUBLIC REPUTATION',
        NOT_AVAILABLE: 'Not available',
        OVERALL_RISK: 'OVERALL RISK',
        BBB: 'BBB',
        BBB_NOT_ACCREDITED: 'Not accredited',
        BBB_ACCREDITATION_UNKNOWN: 'Accreditation unknown',
        BBB_NO_LISTING: 'No listing',
        BBB_NOT_RATED: 'Not rated',
        BBB_REVIEWS_AVG: 'Reviews avg.',
        LOW_RISK: '1/5 - Low Risk',
        MEDIUM_RISK: '3/5 - Medium Risk',
        HIGH_RISK: '5/5 - High Risk',
        RISK_ANALYSIS: 'Risk Analysis',
        REPUTATION_ASSESSMENT: 'Reputation Assessment',
        UNDERWRITING_RECOMMENDATIONS: 'Underwriting Recommendations',
        ACTION_REQUIRED: 'Action Required',
        POSITIVE: 'Positive',
        CAUTION: 'Caution',
        FMCSA_VERIFICATION: 'FMCSA Verification',
        MOTUS_VERIFICATION: 'Motus Verification',
        EXACT_MATCH: 'Exact Match',
        PARTIAL_MATCH: 'Partial Match',
        CARRIER_NAME: 'CARRIER NAME',
        DOT_NUMBER: 'DOT NUMBER',
        REGISTERED_ADDRESS: 'REGISTERED ADDRESS',
        PUBLIC_PRESENCE: 'Public Presence',
        BUSINESS_NAME: 'BUSINESS NAME',
        LOCATION: 'LOCATION',
        COMPANY_IMAGE: 'Company Image',
        MAP: 'Map',
        VIEW_MAP: 'View Map',
        WEBSITE: 'Website',
        CALL: 'Call',
        GET_FULL_REPORT_DATA: 'Generate report',
        EMPTY_DESCRIPTION: "Check this business's public footprint: its website, BBB rating, and customer and employee reviews, summarized into a reputational read for underwriting.",
        REPORT_IN_PROGRESS_TITLE: 'Report in progress',
        REPORT_IN_PROGRESS_MESSAGE: 'We are gathering the reputational data. This can take a few minutes. Feel free to keep working; this page will refresh automatically when the report is ready.',
        REPORT_FAILED_TITLE: 'Report failed',
        REPORT_FAILED_MESSAGE: 'We were unable to complete the reputational report. You can retry now or try again later.',
        RETRY_REPORT: 'RETRY',
        NO_ASSESSMENT_AVAILABLE: 'No assessment available.',
        RATINGS: 'ratings',
        NOT_FOUND: 'Not Found',
        FOUND: 'Found',
        FMCSA_NOT_FOUND_MESSAGE: 'No FMCSA registration found. Additional verification required.',
        MOTUS_NOT_FOUND_MESSAGE: 'No Motus registration found. Additional verification required.',
        PUBLIC_PRESENCE_NOT_FOUND_MESSAGE: 'No public business listing found.',
        GOOGLE_RESULT: 'Google Result',
        BBB_VERIFICATION: 'BBB Verification',
        BBB_ACCREDITED: 'BBB Accredited',
        BBB_RATING: 'BBB RATING',
        YEARS_IN_BUSINESS: 'YEARS IN BUSINESS',
        COMPLAINTS: 'COMPLAINTS',
        CUSTOMER_REVIEWS: 'CUSTOMER REVIEWS',
        PRIMARY_CATEGORY: 'PRIMARY CATEGORY',
        BUSINESS_TYPE: 'BUSINESS TYPE',
        FILE_OPENED: 'FILE OPENED',
        LOCAL_BBB: 'LOCAL BBB',
        COMPLAINTS_3_YEARS: 'Complaints (3 Years)',
        COMPLAINTS_12_MONTHS: 'Complaints (12 Months)',
        RATING_REASONS: 'Rating Reasons',
        CATEGORIES: 'CATEGORIES',
        VIEW_BBB_PROFILE: 'View BBB Profile',
        BBB_NOT_FOUND_MESSAGE: 'No BBB profile found for this business.',
        ACCREDITED: 'Accredited',
        NOT_ACCREDITED: 'Not Accredited',
        PHONE: 'Phone',
        LOW_RISK_LABEL: 'Low Risk',
        MEDIUM_RISK_LABEL: 'Medium Risk',
        HIGH_RISK_LABEL: 'High Risk',
        CHAMELEON_CARRIER_ANALYSIS: 'Chameleon Carrier Analysis',
        COMPUTED: 'Computed',
        RISK: 'Risk',
        MATCH_CLUSTERS: 'Match Clusters',
        RELATED_DOT_NUMBERS: 'Related DOT #s',
        REINCARNATION_CANDIDATES: 'Reincarnation Candidates',
        TOTAL_SCORE: 'Total Score',
        REINCARNATION_PATTERN: 'Reincarnation Pattern',
        UNDELIVERABLE_ADDRESS: 'Undeliverable Address',
        RISK_SUMMARY: 'Risk Summary',
        SCORE_BREAKDOWN: 'Score Breakdown · Weighted Components',
        ENTITY_CONNECTION_NETWORK: 'Entity Connection Network',
        REINCARNATION: '△ Reincarnation',
        REVOKED: 'Revoked',
        EMPLOYEE_INSIGHTS_FROM_INDEED: 'Employee Insights from Indeed',
        COMPANY_NAME_FIELD: 'Company Name',
        OUT_OF_5: 'out of 5',
        EMPLOYEE_REVIEWS: 'employee reviews',
        CEO: 'CEO',
        FOUNDED: 'Founded',
        COMPANY_SIZE: 'Company Size',
        HEADQUARTERS: 'Headquarters',
        VIEW_INDEED_PROFILE: 'View Indeed Profile',
        INDEED_NOT_FOUND_MESSAGE: 'No Indeed company profile found for this business.',
        CRASH_ANALYSIS: 'Crash Analysis',
        CRASH_ANALYSIS_SUBTITLE: 'FMCSA crash risk composite scoring',
        INSPECTION_ANALYSIS: 'Inspection Analysis',
        INSPECTION_ANALYSIS_SUBTITLE: 'FMCSA inspection trend analysis',
        COMPOSITE_SCORE: 'Composite Score',
        PEER_GROUP: 'Peer Group',
        PEER_GROUP_SIZE: 'Peer Group Size',
        POWER_UNITS: 'Power Units',
        DRIVER_COUNT: 'Drivers',
        CRASH_COUNT: 'Total Crashes',
        PREVENTABLE_CRASHES: 'Preventable',
        FATAL_CRASHES: 'Fatal',
        INJURY_CRASHES: 'Injury',
        TOW_AWAY_CRASHES: 'Tow Away',
        INSPECTION_COUNT: 'Inspections',
        OOS_INSPECTIONS: 'OOS Inspections',
        VIOLATION_COUNT: 'Violations',
        BASIC_CATEGORIES: 'BASIC Categories',
        ACTIVE_OOS_ORDER: 'Active OOS Order',
        YES: 'Yes',
        NO: 'No',
        TOP_RISK_FACTORS: 'Top Risk Factors',
        RISK_SCORE_COMPONENTS: 'Risk Score Components',
        CONTRIBUTION: 'Contribution',
        PERCENTILE: 'Percentile',
        WEIGHT: 'Weight',
        DESCRIPTION: 'Description',
        DISTANCE_TO_NEXT_LEVEL: 'Distance to Next Level',
        NEXT_LEVEL: 'Next Level',
        CRASH_METRICS: 'Crash Metrics',
        TREND_DIRECTION: 'Trend Direction',
        TREND_SCORE: 'Trend Score',
        RECENT_PERIOD: 'Last 12 Months',
        PRIOR_PERIOD: '12–24 Months Ago',
        OOS_RATE: 'OOS Rate',
        VIOLATIONS_PER_INSPECTION: 'Violations / Inspection',
        AVG_SEVERITY: 'Avg Severity',
        CLEAN_RATE: 'Clean Rate',
        PERIOD_COMPARISON: 'Period Comparison',
        PEER_CONTEXT: 'Peer Context',
        PEER_AVG_OOS_RATE: 'Peer Avg OOS Rate',
        PEER_AVG_VIOLATION_RATE: 'Peer Avg Violation Rate',
        OOS_RATE_PERCENTILE: 'OOS Rate Percentile',
        VIOLATION_RATE_PERCENTILE: 'Violation Rate Percentile',
        LIFETIME_STATS: 'Lifetime Statistics',
        TOTAL_INSPECTIONS: 'Total Inspections',
        TOTAL_VIOLATIONS: 'Total Violations',
        TOTAL_OOS: 'Total OOS',
        DATA_RANGE: 'Data Range',
        MONTHLY_OOS_RATE_TREND: 'Monthly OOS Rate Trend',
        TOP_CONCERNS: 'Top Concerns',
        CARRIERS: 'carriers',
        POINTS: 'pts',
      },
      BGV: {
        REFRESH_REPORT: 'Refresh Report',
        REPORT_HISTORY: 'Report History',
        REFRESH_CONFIRM_TITLE: 'Refresh Background Report',
        REFRESH_CONFIRM_MESSAGE: 'This will request a new background report and consume credits. Continue?',
        CURRENT_REPORT: 'Current Report',
        PREVIOUS_REPORT: 'Previous Report',
        BACKGROUND_CHECK: 'Background Check',
        CONNECTED_BUSINESS_REPORT: 'Connected Business Report',
        CONNECTED_BUSINESS: 'Connected Business',
        LIST_OF_BUSINESSES: 'List of businesses',
        ABOUT_DEBTOR: 'About Debtor',
        ABOUT_SECURED: 'About Secured',
        ABOUT_CREDITOR: 'About Creditor',
        OFFENCES: 'OFFENSES',
        OFFENCE: 'OFFENSE',
        HINT: 'There’s no PDF Report for this request',
        ATTACH_SUCCESS_MSG: 'Success, report has been added to attachments',
        ATTACH_TO_SAVED_REPORTS: 'Success, your report is attached to saved search reports',
        THERE_WERE_NO_RESULTS: 'There were no results found',
        NO_RESULTS_FOR_OWNER: 'Background Check works best when you provide more details about the Owner, like SSN or DOB. However, please note you may still not find a result after adding those values.',
        VERIFIED: 'Verified',
        ALREADY_REQUESTED: 'Already requested',
        REQUESTED_ON: 'Requested',
        VIEW_REPORT: 'View Report',
        REPORT_CHARGED_ONCE: 'This report is charged once only.',
      },
      BT: {
        BANK_TRANSACTIONS: 'Bank Transactions',
        REQUEST_ACCESS: 'Request bank account access',
        EMPTY_DESCRIPTION: "Email an owner a secure link to connect their bank through Plaid. Once they connect, accounts, transactions and recurring payments appear here.",
        BANK_ACCOUNT_ACCESS: 'Bank Account Access',
        SUCCESS_MSG: 'Email has been sent to owner to request access to the bank account.',
        SUCCESS_RESENT_EMAIL: 'Email has been resent successfully.',
        REQUEST_DATA: 'Request Data',
        REFRESH_DATA: 'Refresh Data',
        TRANSACTIONS: 'Transactions',
        BANK_ACCOUNT_ACCESS_REQUESTS: 'Bank Account Access Requests',
        RECURRENT_TRANSACTIONS: 'Recurrent Transactions',
        INSIGHTS: 'Insights',
        REQUEST_DATA_ERR_MSG: 'Error requesting data',
        SELECT_OWNER: 'Select Owner *',
        SELECT_ACCOUNT: 'Select Account *',
        SELECT_RANGE: 'Select Range *',
        BANK_TRANSACTION_DETAILS: 'Bank Transaction Details',
        RECURRENT_BANK_TRANSACTION_DETAILS: 'Recurrent Bank Transaction Details',
        NEED_TO_REQUEST_BANK_ACCESS: 'First you need to Request Bank Access to an Owner using the button above',
        RECURRING_PAYMENT_DISTRIBUTION: 'Recurring Payment Distribution',
        MONTHLY_STATEMENTS: 'Monthly Statements',
        EXPIRED_ACCESS_PREFIX: 'Access has expired for owners: ',
        EXPIRED_ACCESS_SUFFIX: '. Information may be out of date. Please request access again',
        SOON_TO_EXPIRE_ACCESS_PREFIX: 'Access soon to expire for owners: ',
        SOON_TO_EXPIRE_ACCESS_SUFFIX: '. Please request access again to ensure updates are not interrupted',
      },
      CLIENTS: {
        CONFIRM_TERMINATION: 'Confirm this termination',
        CONFIRM_CONTINUATION: 'Confirm this continuation',
        ALERT_HEADING: ' Are you sure you want to continue?',
        SUCCESS_MSG: 'Continuation Success',
        UCCS: 'UCCs',
        WAITING_RESPONSE: 'Waiting Response',
        SUCCESSFULL_AMENDMENTS: 'Successful Amendments',
        TERMINATION: 'Termination',
        REJECTED: 'Rejected Amendments',
        SUMBIT: 'Submit Continuation',
        CONTINUATION_LISTING: 'Continuation Listing',
        EXPIRED: 'Expired',
        ACTIVE_FILINGS: 'Active Filings',
        SUBMIT_TERMINATION: 'Submit Termination',
        SUBMIT_CONTINUAION: 'Submit Continuation',
        SUBMIT_AMENDMENT: 'Submit Amendment',
        ASSIGN_COLLATERAL: 'Assign Collateral',
        SELECT: 'Please select authorizing party',
        AMENDMENT: 'Amendment',
        DESCRIPTION: 'Description',
        ASSIGN_TO: 'Assign To',
        ENTER_REFERENCE: 'Please enter Filer Reference',
        CLIENT_REFERENCE: 'Please type in the Client Reference',
        JURISDICTION: 'Please select Jurisdiction',
        AUTHORIZING_PARTY: 'Please enter authorizing party',
        NEW_DEBTOR: 'New Debtor',
        EXISTING_DEBTOR: 'Existing Debtor',
        AMENDMENT_FILING_NUMBER: 'Amendment Filing Number',
        UCC_AMENDMENT: 'UCC Amendment',
        PLACEHOLDER: 'Search...'
      },
      FACTORCLOUD_ONBOARD_LABEL: "Use this application for FactorCloud onboarding."
    },
    ADMIN: {
      CREDIT_MEMO_APPROVAL: 'Credit Memo Approval',
      CREDIT_MEMO_REJECTION_EMAILS: 'Email the other approvers when a memo is rejected',
      CUSTOMER_SETTINGS: 'Customer Settings',
      FEATURES_ENABLED: 'Features Enabled',
      FACTORCLOUD_INTEGRATION: 'FactorCloud Settings',
      TRIAL_SETTINGS: 'Trial Settings',
      GMAIL_INTEGRATION: 'Gmail Integration',
      BRIGHTBOLT_INTEGRATION: 'Brightbolt Integration',
      CONNECT_GMAIL: "Connect GMail"
    },
    QUICK_SEARCH: {
      GUIDE: 'Guide',
      QUICK_SEARCH: 'Quick Search',
      SAVED_SEARCHES: 'Saved Searches',
      RECENT_SEARCHES: 'Recent Searches',
    },
    PP: {
      PASSWORD: 'Password',
      PLATFORM_PARTNERS: 'Platform Partners',
      ADD_PLATFORM_PARTNER: 'Add Platform Partner',
      PLATFORM_PARTNER: 'Platform Partner',
      ADD_AUTHORIZATION: 'Add Authorization',
      AUTHORIZATION_LIST: 'List of Authorized Clients',
      CONFIGURE: 'Configure Platfrom Partner',
      PLATFORM_PARTNER_NAME: 'Platform Partner Name',
      YOUR_PASSWORD: 'Your Password is',
      COPY_MSG: 'Copied to clipboard',
      ERROR_MSG: 'Please select client to authorize',
      HINT: 'Please select the role for the above selected client',
      PASSWORD_HINT1: 'Please copy the password as you will not be able to recover it again.',
      PASSWORD_HINT2: 'In case of lost password you must reset it.'
    },
    PLAID: {
      TITLE: 'Plaid Quickstart',
      SUB_TITLE: 'Secure bank account connection for application review',
      BRIEF: 'Plaid is used as an underwriting signal to help assess risk. Once your financial account is connected, Plaid will be able to will display borrower transaction data in a safe and secure way to help in the underwriting process. You are granting Plaid access to retrieve your bank account information straight from your financial institution, including identity, historical and current balance, and historical transactions data. At any time you can review and revoke your information.',
      BRIEF_THRIVORY: 'Plaid is used by Thrivory as an underwriting signal to help assess risk. Once your financial account is connected, Plaid will be able to will display borrower transaction data in a safe and secure way to help in the underwriting process. You are granting Plaid access to retrieve your bank account information straight from your financial institution, including identity, historical and current balance, and historical transactions data. At any time you can review and revoke your information.',
      CONNECT_ALL_ACCOUNTS_TITLE: 'Please connect all of your bank accounts',
      CONNECT_ALL_ACCOUNTS_TEXT_1: 'To complete an accurate review, you must link ',
      CONNECT_ALL_ACCOUNTS_TEXT_BOLD: 'every bank account available to you through Plaid',
      CONNECT_ALL_ACCOUNTS_TEXT_2: ' — including checking, savings, and any business accounts. Providing only a partial picture of your finances may delay your application or affect the outcome.',
      LEARN_MORE_PLAID: 'To learn more about Plaid please visit: ',
      TEXT_LINK_PLAID: 'plaid.com/how-we-handle-data',
      LEARN_MORE_ROXWRITE: 'To learn more about Roxwrite please visit: ',
      TEXT_LINK_ROXWRITE: 'roxwrite.com/privacy-policy',
      AUTHORIZE: 'Authorize Bank Account',
      LINK_SUCCESS: 'Your account has been linked successfully',
      OAUTH_BAD_REQUEST: 'Error While Doing Authentication',
      BANK_AUTHORIZED: 'Bank Account Authorized',
      PROCEEDING_WITH_AUTH: 'Proceeding with Authorization',
      SYNCING_WITH_ROX: 'Syncing with RoxWrite',
      PLEASE_TRY_AGAIN: 'Please Try Again',
      GO_TO_DASHBOARD: 'Go To Dashboard',
      GREAT_MSG: 'Great! you may close the window now, thanks'
    },
    DEMO_MODE: {
      YOU_ARE_USING_DEMO_MODE: "You're using Demo Mode.",
      NO_REAL_DATA_IS_BEING_DISPLAYED: "No real data is being displayed.",
      EXIT_DEMO_MODE: 'Exit Demo Mode',
      DEMO_MODE: 'Demo Mode',
    },
     // Invoice Submission form strings
    INVOICE: "Invoice",
    OWNER_INFORMATION: "Owner Information",
    INVOICE_SUBMISSION_TITLE: "Invoice Submission",
    THANK_YOU_TITLE: 'Thank You!',
    THANK_YOU_BODY: 'Your invoice has been submitted successfully.\nWe appreciate your business.',
    THANK_YOU_BUTTON: 'Go to Login',
    BUSINESS_NAME: 'Business Name',
    BUSINESS_DBA_NAME: 'DBA Name',
    BUSINESS_START_DATE: 'Business Formation Date',
    BUSINESS_ADDRESS: 'Business Address *',
    BUSINESS_ADDRESS_LINE_1: 'Business Address Line 1',
    BUSINESS_ADDRESS_LINE_2: 'Business Address Line 2',
    ZIPCODE: 'Zipcode',
    CITY: 'City',
    COUNTRY: 'Country',
    STATE: 'State',
    ADD_ADDRESS_MANUALLY: 'Add address manually',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    EMAIL: 'Email',
    PHONE: 'Phone',
    DATE_OF_BIRTH: 'Date of Birth',
    SOCIAL_SECURITY_NUMBER: 'Social Security Number',
    ADDRESS: 'Address *',
    ADDRESS_1: 'Address 1',
    ADDRESS_2: 'Address 2',
    SIGNATURE: 'Signature',
    CREATE_SIGNATURE: 'Create a signature',
    SIGNATURE_REQUIRED_INFO: 'Signature is required, Please use your mouse (or finger on touch devices) to draw your signature in the box below. Click "Clear" to reset and try again if needed.',
    CLEAR: 'Clear',
    TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
    FILE_SIZE_WARNING: 'File size cannot exceed 25MB.',
    AT_LEAST_ONE_OWNER: 'At least one owner is required.',
    SIGNATURE_REQUIRED_FOR_OWNER: idx => `Signature is required for Owner ${idx + 1}.`,
    APPLICATION_SUBMITTED: 'Application submitted successfully.',
    SUBMISSION_FAILED: 'Submission failed. Please try again.',
    RECAPTCHA_FAILED: 'Recaptcha verification failed.',
    RECAPTCHA_NOT_LOADED: 'reCAPTCHA not loaded.',
    ZIPCODE_NOT_FOUND: 'Zipcode not found please enter the address manually.'
    ,
    BILLING: {
      YOUR_PLAN: "Your Plan",
      PLAN_DETAILS: "Current plan details and settings.",
      BUY_MORE_CREDITS: "Buy More Credits",
      CURRENT_PLAN: "Current Plan",
      CREDITS: "Credits",
      CREDITS_AVAILABLE: "Credits available",
      CREDITS_USED: "used this period",
      NEXT_BILLING: "Next Billing",
      AUTO_REPLENISH: "Auto-Replenish",
      ON: "On",
      OFF: "Off",
      AVAILABLE_PLANS: "Available Plans",
      PLANS_SUBHEADER: "Choose a monthly plan to unlock discounted credit pricing. The higher your plan, the cheaper your credits become. You can change or cancel your plan anytime, and all credits work across your organizations and never expire.",
      MOST_POPULAR: "Most Popular",
      SWITCH_TO_STARTER: "Switch to Starter",
      UPGRADE_TO: "Upgrade to",
      // Cancel Subscription Dialog
      CANCEL_SUBSCRIPTION_TITLE: "Cancel Subscription",
      CANCEL_SUBSCRIPTION_CONFIRMATION: "Are you sure you want to cancel your {planName} subscription?",
      CANCEL_SUBSCRIPTION_WHAT_HAPPENS: "What happens when you cancel:",
      CANCEL_SUBSCRIPTION_REMAIN_ACTIVE: "Your subscription will remain active until the end of your current billing period.",
      CANCEL_SUBSCRIPTION_SWITCH: "After that, your account will automatically switch to the Starter tier.",
      CANCEL_SUBSCRIPTION_KEEP_CREDITS: "You'll keep all {creditsAvailable} remaining credits in your account.",
      CANCEL_SUBSCRIPTION_CONTINUE_PURCHASE :"You can continue purchasing credits at your discounted rate even after cancellation, until the end of your billing period.",
      CANCEL_SUBSCRIPTION_CREDITS_NEVER_EXPIRE: "Credits never expire and work across all your organization.",
      CANCEL_SUBSCRIPTION_UPGRADE_ANYTIME: "You can upgrade again at any time to regain full benefits.",
      CANCEL_SUBSCRIPTION_REMAINING_CREDITS: "Your remaining credits:",
      CANCEL_SUBSCRIPTION_CURRENT_BALANCE: "Current balance: {creditsAvailable} credits",
      CANCEL_SUBSCRIPTION_CREDITS_REMAIN_AFTER: "These credits will remain available after cancellation",
      CANCEL_SUBSCRIPTION_AUTOREPLENISH: "Auto-replenish settings:",
      CANCEL_SUBSCRIPTION_AUTOREPLENISH_DISABLED: "Will be automatically disabled when you cancel",
      CANCEL_SUBSCRIPTION_AUTOREPLENISH_REENABLE: "You can re-enable this later in your billing settings",
      CANCEL_SUBSCRIPTION_KEEP: "Keep My Subscription",
      CANCEL_SUBSCRIPTION_ACTION: "Cancel Subscription",
      // Change Plan Dialog
      CHANGE_PLAN_TITLE: "Change Plan",
      CHANGE_PLAN_SUBTITLE: "Switch to the {planName}",
      CHANGE_PLAN_CURRENT: "Current Plan:",
      CHANGE_PLAN_NEW: "New Plan:",
      CHANGE_PLAN_MONTHLY_BILLING: "Monthly billing starts immediately: <b>{price}</b>",
      CHANGE_PLAN_NEW_CREDIT_PURCHASES: "New credit purchases: <b>{creditPrice}</b> each {savings}",
      CHANGE_PLAN_EXISTING_CREDITS: "Your existing <b>{credits}</b> credits remain unchanged",
      CHANGE_PLAN_NEXT_BILLING: "Next billing date: <b>{date}</b>",
      CHANGE_PLAN_CANCEL: "Cancel",
      CHANGE_PLAN_CONFIRM: "Confirm",
      // View Report Cost Dialog
      VIEW_REPORT_COST_TITLE: "View Report Costs",
      VIEW_REPORT_COST_SUBTITLE: "Credit cost for each type of report based on your current {planName}.",
      VIEW_REPORT_COST_CLOSE: "Close",
      VIEW_REPORT_COST_LABEL: "Credit cost for each type of report based on your current plan.",
      // Buy Credits Dialog
      BUY_CREDITS_SUBTITLE: "Purchase additional credits for your {planName}.",
      BUY_CREDITS_COST: "Credits cost {creditCost} each", // eslint-disable-line
      BUY_CREDITS_USED: "{creditsAvailable} Credits available",
      BUY_CREDITS_SELECT_AMOUNT: "Select Credit Amount",
      BUY_CREDITS_CREDITS_LABEL: "Credits",
      BUY_CREDITS_TOTAL_PER_CREDIT: "Total price per credit:",
      BUY_CREDITS_TOTAL_PRICE: "Total price",
      BUY_CREDITS_PURCHASE: "Purchase",
      // Usage & Credit Statement
      USAGE_CREDIT_STATEMENT: "Usage & Credit Statement",
      FILTER: "Filter",
      PDF: "PDF",
      CREDIT_BALANCE_STATEMENT: "Credit Balance Statement",
      PERIOD: "Period",
      ALL_TIME: "All time",
      TO: "to",
      PRESENT: "Present",
      INITIAL_BALANCE: "Initial Balance",
      FINAL_BALANCE: "Final Balance",
      CREDITS_UNIT: "credits",
      APPLICATION: "Application",
      REPORT: "Report",
      REQUESTED_BY: "Requested By",
      DATE: "Date",
      BALANCE: "Balance",
      STATUS: "Status",
      START_DATE: "Start Date",
      END_DATE: "End Date",
      // Manage Subscription
      MANAGE_SUBSCRIPTION: "Manage Subscription",
      CANCEL_SUBSCRIPTION_PLAN_TEXT: "Cancel your subscription plan",
      CANCEL_SUBSCRIPTION_BUTTON: "Cancel Subscription",
      NO_SUBSCRIPTION_TEXT: "You don't have a subscription plan with monthly fee. To close your account contact support",
      CONTACT_SUPPORT: "Contact Support",
      // Trial Plan
      TRIAL: "Trial",
      TRIAL_PRICE: "$0",
      TRIAL_INTERVAL: "/month",
      TRIAL_DESCRIPTION: `Includes ${TRIAL_INCLUDED_CREDITS} Credits`,
      TRIAL_BUTTON_TEXT: "Free Plan one time only",
      CURRENT_PLAN_BUTTON: "Current Plan",
      NO_BILLING_SCHEDULED: "No billing scheduled",
      AUTO_REPLENISH_OFF_TEXT: "(Off) Set up auto-replenish",
    },
    HUBSPOT_CONFIG: {
      SYNCHRONIZATION: "Synchronization",
      HUBSPOT_CONFIGURATION_TITLE: "HubSpot Configuration and data sync",
      CONNECTED: "CONNECTED",
      DISCONNECTED: "DISCONNECTED",
      ACTIVE_INTEGRATION_CONNECTED: "Active integration is connected and ready",
      YOUR_HUBSPOT_ACCOUNT_KEY: "Your HubSpot account key",
      DISCONNECT: "Disconnect",
      WHERE_FIND_API_KEY: "Where can I find my API key?",
      AUTHENTICATION_PRIVATE_APP_ACCESS: "AUTHENTICATION Private App Access",
      VERIFY_CONNECT: "Verify & Connect",
      VERIFY_CONNECT_TOOLTIP: "Verify and connect with HubSpot",
      FORCE_MANUAL_UPDATE: "Force manual data update",
      AUTO_CREATE_APPLICATIONS: "Auto-create applications from HubSpot",
      AUTO_CREATE_APPLICATIONS_HELP: "If enabled, Rox will create an application when a deal has exactly one contact and no matching application exists.",
      AUTO_CREATE_HUBSPOT_DEALS: "Create HubSpot deals from Rox applications",
      AUTO_CREATE_HUBSPOT_DEALS_HELP: "If enabled, sync creates a HubSpot deal (and contact) for each Rox application that has no matching deal. Deal amount is set when the application has a contract amount.",
      VIEW_SYNC_EXECUTIONS: "View sync executions",
      SYNC_EXECUTIONS_LOADED: "Sync executions loaded",
      FAILED_TO_LOAD_SYNC_EXECUTIONS: "Failed to load sync executions",
      SYNC_MAY_TAKE_MINUTES: "This may take a few minutes.",
      LAST_SYNC: "Last Sync",
      LAST_SYNC_NEVER: "Last Sync: Never",
      SYNC_EXECUTION_HISTORY: "Sync execution history",
      EXECUTION_ID: "ID",
      STARTED_AT: "Started",
      COMPLETED_AT: "Completed",
      STATUS: "Status",
      DEALS_PROCESSED: "Deals processed",
      DEALS_MATCHED: "Matched",
      NOTES_SYNCED: "Notes synced",
      ERROR: "Error",
      DETAILS: "Details",
      VIEW_DETAILS: "View details",
      EXECUTION_DETAILS: "Execution details",
      NO_DETAILS_AVAILABLE: "No details available",
      CLOSE: "Close",
      COMPLETED_SUCCESSFULLY: "Completed",
      RUNNING: "Running...",
      FAILED: "Failed",
      QUEUED: "Queued",
      PLEASE_ENTER_VALID_API_KEY: "Please enter a valid API key",
      CONNECTED_SUCCESSFULLY: "Connected to HubSpot successfully!",
      INVALID_API_KEY: "Invalid HubSpot API key",
      FAILED_TO_CONNECT: "Failed to connect to HubSpot",
      DISCONNECTED_SUCCESSFULLY: "Disconnected from HubSpot successfully",
      FAILED_TO_DISCONNECT: "Failed to disconnect from HubSpot",
      NO_ACTIVE_CONNECTION: "No active HubSpot connection",
      MANUAL_SYNC_TRIGGERED: "Manual sync triggered successfully",
      FAILED_TO_TRIGGER_SYNC: "Failed to trigger manual sync",
      MANUAL_SYNC_COOLDOWN: "Manual sync can only be triggered 3 hours after the last execution. Please wait.",
      NEXT_MANUAL_SYNC_AT: "Next manual update available at",
      SYNC_ALREADY_IN_PROGRESS: "A sync is already in progress. Please wait for it to complete.",
      CONFIRM_DISCONNECT_TITLE: "Confirm Disconnect",
      CONFIRM_DISCONNECT_MESSAGE: "Are you sure you want to disconnect HubSpot?",
      THIS_WILL_DELETE_CONFIG: "This will delete the configuration and all related data.",
      ACTION_CANNOT_UNDONE: "This action cannot be undone.",
      CANCEL: "Cancel",
      DISCONNECTING: "Disconnecting...",
      DOCUMENT_SYNC_TITLE: "Document synchronization",
      DOCUMENT_SYNC_DESCRIPTION: "Attach ROX documents in HubSpot as:",
      DESTINATION_DEAL: "Deal",
      DESTINATION_COMPANY: "Company",
      DESTINATION_CONTACT: "Contact",
      HUBSPOT_SYNC_DOCUMENTS_LABEL: "Sync documents to HubSpot",
      HUBSPOT_SYNC_DOCUMENTS_HELP: "If enabled, documents uploaded in ROX will be automatically attached to the matching HubSpot deal, company, or contact.",
      DESTINATION_UPDATED: "Document sync target updated",
      MAX_SYNC_SIZE_DESCRIPTION: "Max file size to sync (MB). Larger files are skipped.",
      MAX_SIZE_UPDATED: "Max sync size updated",
      FAILED_TO_UPDATE_MAX_SIZE: "Failed to update max sync size",
      SYNCED_DOCUMENTS_TITLE: "Synced documents",
      SYNCED_DOC_FILE_NAME: "File",
      SYNCED_DOC_SIZE: "Size",
      SYNCED_DOC_DESTINATION: "Destination",
      SYNCED_DOC_STATUS: "Status",
      SYNCED_DOC_FAILURE_REASON: "Failure reason",
      SYNCED_DOC_RETRIES: "Retries",
      SYNCED_DOC_CREATED_AT: "Created",
      SYNCED_DOC_SYNCED_AT: "Synced at",
      SYNCED_DOC_ACTIONS: "Actions",
      SYNCED_DOC_RETRY: "Retry",
      SYNCED_DOC_RETRYING: "Retrying...",
      STATUS_QUEUED: "Queued",
      STATUS_PUSHED: "Pushed",
      STATUS_FAILED: "Failed",
      STATUS_PERMANENTLY_FAILED: "Perm. failed",
      STATUS_SKIPPED: "Skipped",
      FAILED_TO_UPDATE_DESTINATION: "Failed to update document sync target"
    },

          // AR Balance Component
      AR_BALANCE_TITLE: "AR Balance",
      AR_BALANCE_COMPARE_LABEL: "Compare with previous data",
      AR_BALANCE_REQUEST_NEW: "Request New Analysis",
      AR_BALANCE_UPLOAD_REPORT: "Upload New Report",
      AR_BALANCE_UPLOAD_DOCUMENT: "Upload AR Balance Document",
      AR_BALANCE_UPLOAD_SUCCESS: "AR Balance document uploaded successfully!",
      AR_BALANCE_UPLOAD_ERROR: "Failed to upload AR Balance document. Please try again.",
      AR_BALANCE_UPLOADING: "Uploading...",
      AR_BALANCE_PROCESSING: "Processing...",
      AR_BALANCE_REQUESTING: "Requesting...",
      AR_BALANCE_PROCESSING_TITLE: "Processing AR Balance Analysis",
      AR_BALANCE_PROCESSING_MESSAGE: "This may take a few minutes. Please wait while we analyze your AR balance data.",
      AR_BALANCE_STATUS_LABEL: "Status:",
      AR_BALANCE_PROCESSING_STATUS: "Processing...",
      AR_BALANCE_REPORT_GENERATED: "Report Date:",
      AR_BALANCE_COMPARISON_PERIOD: "Comparison Period:",
      AR_BALANCE_ANALYSIS_PROGRESS: "AR Balance analysis is in progress. This may take a few minutes...",
      AR_BALANCE_TOTAL_AR: "Total Account Receivable",
      AR_BALANCE_TOP_CLIENTS: "Top 5 Clients AR Balance",
      AR_BALANCE_CONCENTRATION: "Top 5 Clients AR Concentration (%)",
      AR_BALANCE_HEALTH_ASSESSMENT: "Financial Health Assessment",
      AR_BALANCE_AGING_BUCKETS: "Aging Buckets Amount",
      AR_BALANCE_CUSTOMER_CONCENTRATION: "Customer Concentration",
      AR_BALANCE_TOP_CLIENTS_TITLE: "Top 5 Clients by AR Balance",
      AR_BALANCE_HEALTH_INDICATORS: "Health Indicators",
      AR_BALANCE_OTHER_CLIENTS: "Other Clients",
      AR_BALANCE_TOP_5_CLIENTS: "Top 5 clients",
      AR_BALANCE_REQUEST_SUCCESS: "AR Balance analysis request submitted successfully!",
      AR_BALANCE_REQUEST_ERROR: "Failed to request AR Balance analysis. Please try again.",

      // AR Balance Comparison Component
      AR_BALANCE_COMPARISON_NO_DATA: "No comparison data available",
      AR_BALANCE_COMPARISON_PERIOD_ANALYSIS: "Period-over-period analysis from",
      AR_BALANCE_COMPARISON_TO: "to",
      AR_BALANCE_COMPARISON_KEY_METRICS: "Key Metrics Summary",
      AR_BALANCE_COMPARISON_TOTAL_AR_CHANGE: "Total AR Change",
      AR_BALANCE_COMPARISON_CONCENTRATION_CHANGE: "Concentration Change",
      AR_BALANCE_COMPARISON_CLIENT_CHANGE: "Client Portfolio Change",
      AR_BALANCE_COMPARISON_INCREASE: "increase",
      AR_BALANCE_COMPARISON_DECREASE: "decrease",
      AR_BALANCE_COMPARISON_EXECUTIVE_SUMMARY: "Executive Summary",
      AR_BALANCE_COMPARISON_TREND_ANALYSIS: "Trend Analysis",
      AR_BALANCE_COMPARISON_TOTAL_AR_TREND: "Total AR Trend",
      AR_BALANCE_COMPARISON_CONCENTRATION_TREND: "Concentration Trend",
      AR_BALANCE_COMPARISON_CLIENT_ANALYSIS: "Client Portfolio Analysis",
      AR_BALANCE_COMPARISON_CLIENT_COMPARISON: "Top 5 Client Comparison",
      AR_BALANCE_COMPARISON_CLIENT_MOVEMENT: "Client Portfolio Movement",
      AR_BALANCE_COMPARISON_NEW_CLIENTS: "New Clients",
      AR_BALANCE_COMPARISON_DROPPED_CLIENTS: "Dropped Clients",
      AR_BALANCE_COMPARISON_HEALTH_CHANGES: "Health Indicator Changes",
      AR_BALANCE_COMPARISON_NEW_INDICATORS: "New Risk Indicators",
      AR_BALANCE_COMPARISON_RESOLVED_INDICATORS: "Resolved Indicators",
      AR_BALANCE_COMPARISON_PREVIOUS_PERIOD: "Previous Period",
      AR_BALANCE_COMPARISON_CURRENT_PERIOD: "Current Period",
      AR_BALANCE_COMPARISON_NEW: "New",
      AR_BALANCE_COMPARISON_DROPPED: "Dropped",
      AR_BALANCE_COMPARISON_RESOLVED: "Resolved",
      AR_BALANCE_CURRENT: "Current",
      AR_BALANCE_PREVIOUS: "Previous",
      AR_BALANCE_PREVIOUS_REPORT_GENERATED: "Previous Report Date:",

      // Additional AR Balance strings
      AR_BALANCE_ANALYSIS_REPORT_TITLE: "AR Balance Analysis Report",
      AR_BALANCE_UPLOAD_DESCRIPTION: "Upload your accounts receivable balance document for comprehensive analysis, including aging analysis, customer concentration, and financial health indicators.",
      AR_BALANCE_COMPARISON_STARTED_SUCCESS: "Comparison analysis started successfully",
      AR_BALANCE_COMPARISON_FAILED: "Comparison analysis failed",
      AR_BALANCE_GENERATE_COMPARISON_TITLE: "Generate Comparison Report",
      AR_BALANCE_GENERATE_COMPARISON_MESSAGE: "Do you want to generate a comparison report between your current and previous AR Balance reports? This will analyze changes in totals, aging brackets, customer concentration, and health indicators.",
      AR_BALANCE_CONCENTRATION_RISK: "Concentration Risk",
      AR_BALANCE_HEALTH_TREND: "Health Trend",
      AR_BALANCE_PERIOD_OVER_PERIOD: "Period-over-period",
      AR_BALANCE_REDUCTION: "reduction",
      AR_BALANCE_INCREASE: "increase",
      AR_BALANCE_FROM: "from",
      AR_BALANCE_EMERGING_CONCERNS: "Emerging concerns requiring attention",
      AR_BALANCE_IMPROVED_CONDITIONS: "Improved conditions from previous period",
      AR_BALANCE_CONCENTRATION_RISK_TREND: "Concentration Risk Trend",
      AR_BALANCE_COMPARISON_DATA_LOAD_ERROR: "Failed to load comparison data",
      AR_BALANCE_COMPARISON_START_ERROR: "Failed to start comparison analysis",
      AR_BALANCE_GENERATING_COMPARISON_TITLE: "Generating Comparison Report",
      AR_BALANCE_ANALYZING_CHANGES: "Analyzing changes between your AR Balance reports...",

      BANK_STATEMENT_STATEMENTS: "Statements",
      BANK_STATEMENT_PERIODS_SUFFIX: "periods",
      BANK_STATEMENT_COMPARE_BUTTON: "Compare 2 periods",
      BANK_STATEMENT_UPLOAD_BUTTON: "Upload statement",
      BANK_STATEMENT_VERDICT_LABEL: "VERDICT",
      BANK_STATEMENT_HEALTH_SCORE: "HEALTH SCORE",
      BANK_STATEMENT_STARTING_BALANCE: "STARTING BALANCE",
      BANK_STATEMENT_CREDITS: "CREDITS",
      BANK_STATEMENT_DEBITS: "DEBITS",
      BANK_STATEMENT_NET_CASH_FLOW: "NET CASH FLOW",
      BANK_STATEMENT_ENDING_BALANCE: "ENDING BALANCE",
      BANK_STATEMENT_CASH_MOVEMENT: "Cash movement",
      BANK_STATEMENT_OPENING: "Opening",
      BANK_STATEMENT_CLOSING: "Closing",
      BANK_STATEMENT_IN: "In",
      BANK_STATEMENT_OUT: "Out",
      BANK_STATEMENT_HEALTH_INDICATORS: "Health indicators",
      BANK_STATEMENT_INDICATORS_SUBTITLE_SUFFIX: "signals extracted from the statement",
      BANK_STATEMENT_FEES_IDENTIFIED: "FEES IDENTIFIED",
      BANK_STATEMENT_NO_FEES_REPORTED: "None reported",
      BANK_STATEMENT_NO_FEE_LINE_ITEMS: "No fee line items in this statement.",
      BANK_STATEMENT_TAKEAWAYS: "Takeaways",
      BANK_STATEMENT_TAKEAWAYS_SUBTITLE: "Note a finding or push it into the credit memo",
      BANK_STATEMENT_NO_STATEMENTS_TITLE: "No bank statements yet",
      BANK_STATEMENT_NO_STATEMENTS_MESSAGE: "Upload a bank statement to generate a health assessment, cash movement chart, and period-over-period comparisons.",
      BANK_STATEMENT_PROCESSING_TITLE: "Processing bank statement",
      BANK_STATEMENT_PROCESSING_MESSAGE: "This may take a few minutes while we analyze your statement.",
      BANK_STATEMENT_UPLOAD_DOCUMENT: "Upload Bank Statement",
      BANK_STATEMENT_UPLOADING: "Uploading...",
      BANK_STATEMENT_UPLOAD_SUCCESS: "Bank statement uploaded successfully!",
      BANK_STATEMENT_UPLOAD_ERROR: "Failed to upload bank statement. Please try again.",
      BANK_STATEMENT_GENERATING_COMPARISON_TITLE: "Generating Comparison Report",
      BANK_STATEMENT_ANALYZING_CHANGES: "Analyzing changes between your bank statements...",
      BANK_STATEMENT_COMPARISON_FAILED: "Failed to generate the comparison. Please try again.",
      BANK_STATEMENT_CURRENT: "Current",
      BANK_STATEMENT_PREVIOUS: "Previous",

      BANK_STATEMENT_GENERATE_COMPARISON_TITLE: "Generate Comparison Report",
      BANK_STATEMENT_GENERATE_COMPARISON_MESSAGE: "Do you want to generate a comparison report between your current and previous Bank Statements? This will identify trends in key metrics and health indicators.",

      // Bank Statement Comparison Component
      BANK_STATEMENT_COMPARISON_GENERATED_PREFIX: "Comparison generated",
      BANK_STATEMENT_BACK_TO_STATEMENT: "Back to statement",
      BANK_STATEMENT_EXPORT_COMPARISON: "Export comparison",
      BANK_STATEMENT_PERIOD_OVER_PERIOD: "Period over period",
      BANK_STATEMENT_PERIOD_OVER_PERIOD_SUBTITLE: "Each metric is scaled to its own largest value, so bars are comparable within a metric but not across them",
      BANK_STATEMENT_WHAT_CHANGED: "What changed in the signals",
      BANK_STATEMENT_RESOLVED_EXPLAINER: "\"Resolved\" means the signal is no longer present this period - not necessarily that the underlying issue was fixed.",
      BANK_STATEMENT_PDF_TITLE: "Bank Statement Comparison",

      // Bank Transactions source tabs (statement upload vs Plaid)
      BANK_SOURCE_TAB_STATEMENTS: "Statement Analysis",
      BANK_SOURCE_TAB_CONNECTED: "Connected Account",
      BANK_CONNECTED_TITLE: "Connected account reporting is not enabled yet",
      BANK_CONNECTED_MESSAGE: "Once a bank account is linked through Plaid, transaction charts, insights and recurring-payment reports will appear here. Requesting access still works, but the report view is currently turned off.",
      BANK_STATEMENT_EXPORT_SUCCESS: "Comparison exported.",
      BANK_STATEMENT_EXPORT_FAILED: "Couldn't generate the PDF. Please try again.",
      BANK_STATEMENT_NEW: "NEW",
      BANK_STATEMENT_PERSISTENT: "PERSISTENT",
      BANK_STATEMENT_RESOLVED: "RESOLVED",
      BANK_STATEMENT_ACCOUNT_STATE_TAB: "Account state",
      BANK_STATEMENT_OVERALL_HEALTH_TAB: "Overall health",
      BANK_STATEMENT_TAKEAWAY_ANALYSIS_TAB: "Takeaway analysis",
      BANK_STATEMENT_NO_COMPARISON_DATA: "No comparison data available for these two periods.",

      // Balance Sheet Component
      BALANCE_SHEET_TAB_TITLE: "Balance Sheet",
      BALANCE_SHEET_STATEMENTS: "Balance sheets",
      BALANCE_SHEET_PERIODS_SUFFIX: "periods",
      BALANCE_SHEET_COMPARE_BUTTON: "Compare 2 periods",
      BALANCE_SHEET_UPLOAD_BUTTON: "Upload balance sheet",
      BALANCE_SHEET_UPLOAD_DOCUMENT: "Upload Balance Sheet",
      BALANCE_SHEET_UPLOADING: "Uploading...",
      BALANCE_SHEET_UPLOAD_SUCCESS: "Balance sheet uploaded successfully!",
      BALANCE_SHEET_UPLOAD_ERROR: "Failed to upload balance sheet. Please try again.",
      BALANCE_SHEET_PROCESSING_TITLE: "Processing balance sheet",
      BALANCE_SHEET_PROCESSING_MESSAGE: "This may take a few minutes while we analyze the statement.",
      BALANCE_SHEET_NO_REPORTS_TITLE: "No balance sheets yet",
      BALANCE_SHEET_NO_REPORTS_MESSAGE: "Upload a balance sheet to generate a solvency and liquidity assessment, a composition breakdown, and period-over-period comparisons.",
      BALANCE_SHEET_VERDICT_LABEL: "VERDICT",
      BALANCE_SHEET_HEALTH_SCORE: "HEALTH SCORE",
      BALANCE_SHEET_HEALTH: "Health",
      BALANCE_SHEET_TOTAL_ASSETS: "TOTAL ASSETS",
      BALANCE_SHEET_TOTAL_LIABILITIES: "TOTAL LIABILITIES",
      BALANCE_SHEET_WORKING_CAPITAL: "WORKING CAPITAL",
      BALANCE_SHEET_DEBT_TO_EQUITY: "DEBT-TO-EQUITY",
      BALANCE_SHEET_TOTAL_EQUITY: "TOTAL EQUITY",
      BALANCE_SHEET_TOTAL_AR: "TOTAL AR",
      BALANCE_SHEET_TOTAL_DEBT: "TOTAL DEBT",
      BALANCE_SHEET_TOTAL_ASSETS_SHORT: "total assets",
      BALANCE_SHEET_COMPOSITION: "Composition",
      BALANCE_SHEET_ASSETS_COLUMN: "ASSETS",
      BALANCE_SHEET_CLAIMS_COLUMN: "LIABILITIES + EQUITY",
      BALANCE_SHEET_TRAJECTORY: "Trajectory.",
      BALANCE_SHEET_HEALTH_INDICATORS: "Health indicators",
      BALANCE_SHEET_INDICATORS_SUBTITLE_SUFFIX: "signals derived from the reported figures",
      BALANCE_SHEET_TAKEAWAYS: "Takeaways",
      BALANCE_SHEET_TAKEAWAYS_SUBTITLE: "Extracted from the uploaded balance sheet",
      BALANCE_SHEET_CURRENT: "Current",
      BALANCE_SHEET_PREVIOUS: "Previous",
      BALANCE_SHEET_GENERATE_COMPARISON_TITLE: "Generate Comparison Report",
      BALANCE_SHEET_GENERATE_COMPARISON_MESSAGE: "Do you want to generate a comparison report between your current and previous Balance Sheets? This will identify trends in key metrics and health indicators.",

      // Balance Sheet derived copy
      BALANCE_SHEET_HEADLINE_INSOLVENT: "Insolvent on paper.",
      BALANCE_SHEET_HEADLINE_ILLIQUID: "Illiquid. Equity under pressure.",
      BALANCE_SHEET_HEADLINE_THIN: "Solvent, but thin.",
      BALANCE_SHEET_HEADLINE_SOLID: "Solvent and liquid.",
      BALANCE_SHEET_AR_SHORT: "AR",
      BALANCE_SHEET_AR_IS: "AR is",
      BALANCE_SHEET_OF_ASSETS: "of assets",
      BALANCE_SHEET_OF_TOTAL_ASSETS: "of total assets",
      BALANCE_SHEET_NO_AR_REPORTED: "No receivables reported",
      BALANCE_SHEET_CURRENT_RATIO: "Current ratio",
      BALANCE_SHEET_NO_CURRENT_RATIO: "Current ratio not reported",
      BALANCE_SHEET_DEBT_TO_EQUITY_LABEL: "Debt-to-equity",
      BALANCE_SHEET_TOTAL_LIABILITIES_LABEL: "Total liabilities",
      BALANCE_SHEET_TOTAL_EQUITY_LABEL: "Total equity",
      BALANCE_SHEET_ACCOUNTS_RECEIVABLE: "Accounts receivable",
      BALANCE_SHEET_OTHER_ASSETS: "Other assets",
      BALANCE_SHEET_UNDER: "under",
      BALANCE_SHEET_ABOVE: "above",
      BALANCE_SHEET_ABOVE_THE: "Above the",
      BALANCE_SHEET_WITHIN_THE: "Within the",
      BALANCE_SHEET_THRESHOLD: "threshold",
      BALANCE_SHEET_VS: "vs",
      BALANCE_SHEET_INDICATOR_RATIO_BELOW_FLOOR: "Below 1.00 - short-term obligations exceed current assets.",
      BALANCE_SHEET_INDICATOR_RATIO_BELOW_COMFORT: "Below the 1.50 comfort threshold.",
      BALANCE_SHEET_INDICATOR_RATIO_HEALTHY: "At or above the 1.50 comfort threshold.",
      BALANCE_SHEET_INDICATOR_WC_POSITIVE: "Working capital positive",
      BALANCE_SHEET_INDICATOR_WC_NEGATIVE: "Working capital negative",
      BALANCE_SHEET_INDICATOR_LEVERAGE_ABOVE: "Above the 2.00 threshold.",
      BALANCE_SHEET_INDICATOR_LEVERAGE_WITHIN: "Within the 2.00 threshold.",
      BALANCE_SHEET_INDICATOR_AGAINST_EQUITY: "of debt against",
      BALANCE_SHEET_INDICATOR_AR_ABOVE: "Above the",
      BALANCE_SHEET_INDICATOR_AR_BELOW: "Below the",
      BALANCE_SHEET_INDICATOR_CONCENTRATION_THRESHOLD: "concentration threshold.",
      BALANCE_SHEET_INDICATOR_EQUITY_POSITIVE: "Equity positive",
      BALANCE_SHEET_INDICATOR_EQUITY_NEGATIVE: "Equity exhausted",
      BALANCE_SHEET_INDICATOR_DEBT_SPREAD: "Debt exceeds reported liabilities",
      BALANCE_SHEET_INDICATOR_DEBT_ON_FILE: "Debt on file",
      BALANCE_SHEET_INDICATOR_IN_LIABILITIES: "in total liabilities.",
      BALANCE_SHEET_BOTH_COLUMNS_TOTAL: "Both columns total",
      BALANCE_SHEET_CHECK_HOLDS: "the balance check holds.",
      BALANCE_SHEET_CHECK_PASSED_TOTALS_DIFFER: "The report's balance check passed, but the reported totals do not sum:",
      BALANCE_SHEET_CHECK_FAILED: "The balance check failed:",
      BALANCE_SHEET_IN_ASSETS_AGAINST: "in assets against",
      BALANCE_SHEET_IN_CLAIMS: "in liabilities and equity",
      BALANCE_SHEET_TRAJECTORY_PREFIX: "of assets are receivables. A",
      BALANCE_SHEET_TRAJECTORY_IMPAIRMENT: "impairment of the AR book",
      BALANCE_SHEET_TRAJECTORY_CONSUMES: "would consume",
      BALANCE_SHEET_TRAJECTORY_OF_EQUITY: "of total equity.",
      BALANCE_SHEET_TRAJECTORY_WIPES_EQUITY: "would wipe out total equity entirely.",

      // Balance Sheet Comparison Component
      BALANCE_SHEET_BACK: "Back to balance sheet",
      BALANCE_SHEET_GENERATING_COMPARISON_TITLE: "Generating Comparison Report",
      BALANCE_SHEET_ANALYZING_CHANGES: "Analyzing changes between the two balance sheets...",
      BALANCE_SHEET_COMPARISON_FAILED: "Failed to generate the comparison. Please try again.",
      BALANCE_SHEET_COMPARISON_GENERATED_PREFIX: "Comparison generated",
      BALANCE_SHEET_TREND_IMPROVING: "Improving",
      BALANCE_SHEET_TREND_DETERIORATING: "Deteriorating",
      BALANCE_SHEET_TREND_STABLE: "Stable",
      BALANCE_SHEET_PERIOD_OVER_PERIOD: "Period over period",
      BALANCE_SHEET_PERIOD_OVER_PERIOD_SUBTITLE: "Each metric is scaled to its own largest value, so bars are comparable within a metric but not across them",
      BALANCE_SHEET_WHERE_SHIFTED: "Where the balance sheet shifted",
      BALANCE_SHEET_WHERE_SHIFTED_SUBTITLE: "Segment share of its own column",
      BALANCE_SHEET_TRIGGERED_FLAGS: "Triggered flags",
      BALANCE_SHEET_TRIGGERED_FLAGS_SUBTITLE: "Raised by the comparison between these two periods",
      BALANCE_SHEET_NO_TRIGGERED_FLAGS: "No flags were raised between these two periods.",
      BALANCE_SHEET_POSITION_ANALYSIS_TAB: "Position analysis",
      BALANCE_SHEET_OVERALL_HEALTH_TAB: "Overall health",
      BALANCE_SHEET_TAKEAWAY_ANALYSIS_TAB: "Takeaway analysis",
      BALANCE_SHEET_NO_COMPARISON_DATA: "No comparison data available for these two periods.",
      BALANCE_SHEET_UNCHANGED: "Unchanged",

      // Income Statement Component
      INCOME_STATEMENT_TAB_TITLE: "Income Statement",
      INCOME_STATEMENT_STATEMENTS: "Income statements",
      INCOME_STATEMENT_PERIODS_SUFFIX: "periods",
      INCOME_STATEMENT_COMPARE_BUTTON: "Compare 2 periods",
      INCOME_STATEMENT_UPLOAD_BUTTON: "Upload income statement",
      INCOME_STATEMENT_UPLOAD_DOCUMENT: "Upload Income Statement",
      INCOME_STATEMENT_UPLOADING: "Uploading...",
      INCOME_STATEMENT_UPLOAD_SUCCESS: "Income statement uploaded successfully!",
      INCOME_STATEMENT_UPLOAD_ERROR: "Failed to upload income statement. Please try again.",
      INCOME_STATEMENT_ANALYSIS_FAILED: "The last income statement could not be analyzed. Upload it again or try another file.",
      INCOME_STATEMENT_PROCESSING_TITLE: "Processing income statement",
      INCOME_STATEMENT_PROCESSING_MESSAGE: "This may take a few minutes while we analyze the statement.",
      INCOME_STATEMENT_NO_REPORTS_TITLE: "No income statements yet",
      INCOME_STATEMENT_NO_REPORTS_MESSAGE: "Upload an income statement (profit and loss) to generate a profitability and debt service assessment, a revenue breakdown, and period-over-period comparisons.",
      INCOME_STATEMENT_VERDICT_LABEL: "VERDICT",
      INCOME_STATEMENT_HEALTH_SCORE: "HEALTH SCORE",
      INCOME_STATEMENT_HEALTH: "Health",
      INCOME_STATEMENT_TOTAL_REVENUE: "TOTAL REVENUE",
      INCOME_STATEMENT_GROSS_PROFIT: "GROSS PROFIT",
      INCOME_STATEMENT_OPERATING_INCOME: "OPERATING INCOME",
      INCOME_STATEMENT_NET_INCOME: "NET INCOME",
      INCOME_STATEMENT_EBITDA: "EBITDA",
      INCOME_STATEMENT_GROSS_MARGIN_UPPER: "GROSS MARGIN",
      INCOME_STATEMENT_NET_MARGIN_UPPER: "NET MARGIN",
      INCOME_STATEMENT_TOTAL_REVENUE_SHORT: "total revenue",
      INCOME_STATEMENT_TOTAL_REVENUE_TITLE: "Total revenue",
      INCOME_STATEMENT_GROSS_PROFIT_LABEL: "Gross profit",
      INCOME_STATEMENT_OPERATING_INCOME_LABEL: "Operating income",
      INCOME_STATEMENT_NET_INCOME_LABEL: "Net income",
      INCOME_STATEMENT_COGS_LABEL: "Cost of goods sold",
      INCOME_STATEMENT_OPERATING_EXPENSES_LABEL: "Operating expenses",
      INCOME_STATEMENT_BELOW_OPERATING_LABEL: "Interest, taxes and other",
      INCOME_STATEMENT_GROSS_MARGIN: "Gross margin",
      INCOME_STATEMENT_OPERATING_MARGIN: "Operating margin",
      INCOME_STATEMENT_NET_MARGIN: "Net margin",
      INCOME_STATEMENT_EBITDA_MARGIN: "EBITDA margin",
      INCOME_STATEMENT_INTEREST_EXPENSE: "INTEREST EXPENSE",
      INCOME_STATEMENT_INTEREST_COVERAGE: "Interest coverage",
      INCOME_STATEMENT_COGS_SHORT: "COGS",
      INCOME_STATEMENT_OF_REVENUE: "of revenue",
      INCOME_STATEMENT_NO_COST_BREAKDOWN: "No cost breakdown reported",
      INCOME_STATEMENT_NO_DA_REPORTED: "No depreciation or amortization reported",
      INCOME_STATEMENT_NOT_REPORTED_SUFFIX: "not reported",
      INCOME_STATEMENT_POINTS: "pts",
      INCOME_STATEMENT_UNDER: "under",
      INCOME_STATEMENT_ABOVE: "above",
      INCOME_STATEMENT_VS: "vs",
      INCOME_STATEMENT_THRESHOLD: "threshold.",
      INCOME_STATEMENT_WHERE_REVENUE_WENT: "Where revenue went",
      INCOME_STATEMENT_NO_REVENUE_BREAKDOWN: "Revenue was not reported, so the breakdown cannot be drawn.",
      INCOME_STATEMENT_HEALTH_INDICATORS: "Health indicators",
      INCOME_STATEMENT_INDICATORS_SUBTITLE_SUFFIX: "signals derived from the reported figures",
      INCOME_STATEMENT_STRENGTHS: "STRENGTHS",
      INCOME_STATEMENT_CONCERNS: "CONCERNS",
      INCOME_STATEMENT_TAKEAWAYS: "Takeaways",
      INCOME_STATEMENT_TAKEAWAYS_SUBTITLE: "Extracted from the uploaded income statement",
      INCOME_STATEMENT_CURRENT: "Current",
      INCOME_STATEMENT_PREVIOUS: "Previous",
      INCOME_STATEMENT_GENERATE_COMPARISON_TITLE: "Generate Comparison Report",
      INCOME_STATEMENT_GENERATE_COMPARISON_MESSAGE: "Do you want to generate a comparison report between your current and previous Income Statements? This will identify trends in revenue, margins, profitability and debt service.",

      // Income Statement derived copy
      INCOME_STATEMENT_HEADLINE_INCOMPLETE: "Net result not reported.",
      INCOME_STATEMENT_HEADLINE_LOSS: "Operating at a loss.",
      INCOME_STATEMENT_HEADLINE_OPERATING_LOSS: "Core operations lose money.",
      INCOME_STATEMENT_HEADLINE_DEBT_TIGHT: "Profitable, but debt service is tight.",
      INCOME_STATEMENT_HEADLINE_THIN: "Profitable, but thin.",
      INCOME_STATEMENT_HEADLINE_SOLID: "Profitable and efficient.",
      INCOME_STATEMENT_HEADLINE_WATCH: "Profitable, but under watch.",
      INCOME_STATEMENT_HEADLINE_AT_RISK: "Profitable, but at risk.",
      INCOME_STATEMENT_GROSS_MARGIN_NA: "Gross margin not applicable: no cost of sales on the statement",
      INCOME_STATEMENT_INDICATOR_BELOW_THE: "Below the",
      INCOME_STATEMENT_INDICATOR_AT_OR_ABOVE_THE: "At or above the",
      INCOME_STATEMENT_INDICATOR_OPERATING_LOSS: "Operating expenses exceed gross profit.",
      INCOME_STATEMENT_INDICATOR_NET_LOSS: "Net loss",
      INCOME_STATEMENT_INDICATOR_NET_INCOME_POSITIVE: "Net income positive",
      INCOME_STATEMENT_INDICATOR_COVERAGE_BELOW_FLOOR: "Below the 1.50x floor - operating income does not cover interest.",
      INCOME_STATEMENT_INDICATOR_COVERAGE_BELOW_COMFORT: "Below the 3.00x comfort threshold.",
      INCOME_STATEMENT_INDICATOR_COVERAGE_HEALTHY: "At or above the 3.00x comfort threshold.",
      INCOME_STATEMENT_INDICATOR_NO_INTEREST: "No interest expense reported",
      INCOME_STATEMENT_INDICATOR_NO_INTEREST_SUBTEXT: "Debt service could not be assessed from this statement.",
      INCOME_STATEMENT_INDICATOR_DA_ADDED_BACK: "adding back D&A of",
      INCOME_STATEMENT_CHECK_HOLDS: "Revenue less costs and expenses reconciles with the reported gross and operating income.",
      INCOME_STATEMENT_CHECK_PARTIAL: "The reported figures reconcile, but not every subtotal was printed on the statement.",
      INCOME_STATEMENT_CHECK_INCOMPLETE: "Not enough figures were reported to check the statement's arithmetic.",
      INCOME_STATEMENT_CHECK_FAILED: "The reported figures do not reconcile:",

      // Cash Flow Statement Component
      CASH_FLOW_TAB_TITLE: "Cash Flow",
      CASH_FLOW_STATEMENTS: "Cash flow statements",
      CASH_FLOW_PERIODS_SUFFIX: "periods",
      CASH_FLOW_UPLOAD_BUTTON: "Upload cash flow statement",
      CASH_FLOW_UPLOADING: "Uploading...",
      CASH_FLOW_UPLOAD_SUCCESS: "Cash flow statement uploaded successfully!",
      CASH_FLOW_UPLOAD_ERROR: "Failed to upload cash flow statement. Please try again.",
      CASH_FLOW_NO_REPORTS_TITLE: "No cash flow statements yet",
      CASH_FLOW_NO_REPORTS_MESSAGE: "Upload a statement of cash flows to extract every period it reports, its operating, investing and financing activities, the cash reconciliation and the checks on its arithmetic.",
      CASH_FLOW_PROCESSING_TITLE: "Processing cash flow statement",
      CASH_FLOW_PROCESSING_MESSAGE: "This may take a minute while we read every period of the statement.",
      CASH_FLOW_ANALYSIS_FAILED: "The last cash flow statement could not be analyzed. Upload it again or try another file.",
      CASH_FLOW_LATEST: "Latest",
      CASH_FLOW_LAST_YEAR_SHOWN: "showing the last full year",
      CASH_FLOW_HEADLINE_INCOMPLETE: "Operating cash flow not reported.",
      CASH_FLOW_HEADLINE_BURN: "Operations consume cash.",
      CASH_FLOW_HEADLINE_CAPEX: "Cash generated, spent on capital expenditures.",
      CASH_FLOW_HEADLINE_DRAWDOWN: "Cash generated, but the balance fell.",
      CASH_FLOW_HEADLINE_SOLID: "Cash generative and self-funded.",
      CASH_FLOW_HEADLINE_WATCH: "Cash generative, but under watch.",
      CASH_FLOW_HEADLINE_AT_RISK: "Cash generative, but at risk.",
      CASH_FLOW_HEALTH_SCORE: "HEALTH SCORE",
      CASH_FLOW_HEALTH: "Health",
      CASH_FLOW_VERDICT_LABEL: "VERDICT",
      CASH_FLOW_OBSERVATIONS: "Observations",
      CASH_FLOW_KPI_OPERATING: "Operating cash flow",
      CASH_FLOW_KPI_OF_NET_INCOME: "of net income",
      CASH_FLOW_KPI_NO_NET_INCOME: "Net income not reported or not positive",
      CASH_FLOW_KPI_FREE_CASH_FLOW: "Free cash flow",
      CASH_FLOW_KPI_AFTER_CAPEX: "after capital expenditures of",
      CASH_FLOW_KPI_NO_CAPEX: "Capital expenditures not reported",
      CASH_FLOW_KPI_NET_CHANGE: "Net change in cash",
      CASH_FLOW_KPI_DEBT_COVERAGE: "Operating cash covers debt repayments",
      CASH_FLOW_KPI_REPAID: "repaid",
      CASH_FLOW_KPI_NO_DEBT: "No debt principal repayments reported",
      CASH_FLOW_KPI_ENDING_CASH: "Ending cash",
      CASH_FLOW_KPI_FROM: "From",
      CASH_FLOW_KPI_NO_BEGINNING: "Opening balance not reported",
      CASH_FLOW_STRUCTURE: "Cash flow structure",
      CASH_FLOW_STRUCTURE_COLUMN_ITEM: "Line",
      CASH_FLOW_STRUCTURE_COLUMN_TYPE: "Activity",
      CASH_FLOW_STRUCTURE_COLUMN_CONCEPT: "Concept",
      CASH_FLOW_STRUCTURE_COLUMN_AMOUNT: "Period",
      CASH_FLOW_TYPE_OPERATING: "Operating",
      CASH_FLOW_TYPE_INVESTING: "Investing",
      CASH_FLOW_TYPE_FINANCING: "Financing",
      CASH_FLOW_NET_CASH_OPERATING: "Net cash from operating activities",
      CASH_FLOW_NET_CASH_INVESTING: "Net cash from investing activities",
      CASH_FLOW_NET_CASH_FINANCING: "Net cash from financing activities",
      CASH_FLOW_ANALYSIS_TITLE: "Analysis",
      CASH_FLOW_ANALYSIS_SUBTITLE: "Computed from the verified figures of the period",
      CASH_FLOW_NO_ANALYSIS: "No facts could be established for this period.",
      CASH_FLOW_AMBIGUOUS_LATEST: "Several columns share the latest period end; the main view was chosen by coverage, not by date alone.",
      CASH_FLOW_METHOD_DIRECT: "Direct method",
      CASH_FLOW_METHOD_INDIRECT: "Indirect method",
      CASH_FLOW_METHOD_UNKNOWN: "Method not determined",
      CASH_FLOW_SCALE_UNITS: "amounts in units",
      CASH_FLOW_SCALE_PREFIX: "printed in",
      CASH_FLOW_CONFIDENCE: "Confidence",
      CASH_FLOW_UNAUDITED: "unaudited",
      CASH_FLOW_CONSOLIDATED: "consolidated",
      CASH_FLOW_SECTION_OPERATING: "Operating activities",
      CASH_FLOW_SECTION_INVESTING: "Investing activities",
      CASH_FLOW_SECTION_FINANCING: "Financing activities",
      CASH_FLOW_NET_CASH: "Net cash",
      CASH_FLOW_NOT_REPORTED: "not reported",
      CASH_FLOW_DERIVED: "derived",
      CASH_FLOW_NO_LINES: "No lines captured in this section.",
      CASH_FLOW_RECONCILIATION: "Cash reconciliation",
      CASH_FLOW_CHANGE_BEFORE_FX: "Net change before FX",
      CASH_FLOW_FX_EFFECT: "Effect of exchange rates",
      CASH_FLOW_NET_CHANGE: "Net change in cash",
      CASH_FLOW_BEGINNING_CASH: "Beginning cash",
      CASH_FLOW_ENDING_CASH: "Ending cash",
      CASH_FLOW_SCOPE_PREFIX: "Balances cover",
      CASH_FLOW_SUPPLEMENTAL: "Supplemental disclosures",
      CASH_FLOW_NONCASH: "Noncash investing and financing activities",
      CASH_FLOW_OTHER_LINES: "Other lines on the statement",
      CASH_FLOW_UNMAPPED: "Lines kept under their own label",
      CASH_FLOW_CHECKS_TITLE: "Checks",
      CASH_FLOW_CHECK_NOT_RUN: "not run",
      CASH_FLOW_ISSUES_TITLE: "Validation issues",
      CASH_FLOW_DOCUMENT_NOTES: "Document notes",
      CASH_FLOW_PAGE_PREFIX: "p.",

      // DSCR Component
      DSCR_TAB_TITLE: "DSCR",
      DSCR_EYEBROW: "DEBT SERVICE COVERAGE",
      DSCR_FORMULA: "DSCR = EBITDA / (Principal paid + Cash interest paid)",
      DSCR_SCORE_LABEL: "DSCR",
      DSCR_INDICATIVE_LABEL: "INDICATIVE DSCR",
      DSCR_TARGET_PREFIX: "Target",
      DSCR_PERIOD_PREFIX: "Period",
      DSCR_LOAD_ERROR: "The DSCR could not be loaded",
      DSCR_FORBIDDEN: "DSCR analysis is not enabled for this client",
      DSCR_EMPTY_TITLE: "No DSCR yet",
      DSCR_EMPTY_MESSAGE: "Upload an income statement and a cash flow statement for the same period; the DSCR is computed from their analyses, with no extra credits.",
      DSCR_STATUS_COMPLETE: "Complete",
      DSCR_STATUS_PARTIAL: "Partial",
      DSCR_STATUS_NEEDS_VALIDATION: "Needs validation",
      DSCR_STATUS_MISSING_DOCUMENTS: "Missing documents",
      DSCR_STATUS_MISSING_DATA: "Missing data",
      DSCR_STATUS_INCOMPATIBLE_PERIODS: "Incompatible periods",
      DSCR_STATUS_NOT_APPLICABLE: "Not applicable",
      DSCR_HEADLINE_COMPLETE: "Operating earnings cover the identified debt service",
      DSCR_HEADLINE_BELOW_TARGET: "Coverage is below the target ratio",
      DSCR_HEADLINE_BELOW_ONE: "Operating earnings do not cover the debt service",
      DSCR_HEADLINE_PARTIAL: "An indicative ratio on the debt service identified so far",
      DSCR_HEADLINE_NEEDS_VALIDATION: "A figure is pending validation before the ratio is definitive",
      DSCR_HEADLINE_MISSING_DOCUMENTS: "The DSCR needs both an income statement and a cash flow statement",
      DSCR_HEADLINE_MISSING_DATA: "The documents do not carry the figures the ratio needs",
      DSCR_HEADLINE_INCOMPATIBLE_PERIODS: "The two documents cover different periods",
      DSCR_HEADLINE_NOT_APPLICABLE: "No debt service was identified in this period",
      DSCR_MISSING_HEAD: "MISSING",
      DSCR_WARNINGS_HEAD: "WARNINGS",
      DSCR_INTEREST_COVERAGE: "Interest coverage (EBITDA / interest expense)",
      DSCR_INTEREST_COVERAGE_NOTE: "a different metric from the DSCR, shown while the principal paid is unknown",
      DSCR_KPI_EBITDA: "EBITDA",
      DSCR_KPI_PRINCIPAL: "PRINCIPAL PAID",
      DSCR_KPI_INTEREST: "CASH INTEREST PAID",
      DSCR_KPI_DEBT_SERVICE: "TOTAL DEBT SERVICE",
      DSCR_METHOD_REPORTED: "reported on the income statement",
      DSCR_METHOD_DERIVED: "derived on the income statement",
      DSCR_PRINCIPAL_COMPLETE: "every financing outflow classified",
      DSCR_PRINCIPAL_PARTIAL: "some financing outflows unclassified",
      DSCR_PRINCIPAL_NOT_FOUND: "no repayment line on the cash flow statement",
      DSCR_INTEREST_CASH_FLOW: "from the cash flow statement",
      DSCR_INTEREST_ESTIMATE: "estimated from the accrued interest expense",
      DSCR_INTEREST_MISSING: "not on the cash flow statement",
      DSCR_DEBT_SERVICE_NOTE: "identified principal plus cash interest",
      DSCR_COMPONENTS_TITLE: "Components",
      DSCR_COMPONENTS_SUBTITLE: "Each figure with the line of the document it comes from",
      DSCR_COL_COMPONENT: "Component",
      DSCR_COL_SOURCE: "Source line",
      DSCR_COL_AMOUNT: "Amount",
      DSCR_ROW_EBITDA: "EBITDA",
      DSCR_ROW_TERM_DEBT: "Term debt repayments",
      DSCR_ROW_FINANCE_LEASES: "Finance lease payments",
      DSCR_ROW_LOC: "Line of credit (net movement)",
      DSCR_ROW_LOC_NOTE: "not counted as principal; needs validation",
      DSCR_ROW_UNCLASSIFIED: "Unclassified financing outflow",
      DSCR_ROW_INTEREST: "Cash interest paid",
      DSCR_ROW_ACCRUED_INTEREST: "Accrued interest expense (income statement)",
      DSCR_ROW_ACCRUED_INTEREST_NOTE: "for reference; not added to the debt service",
      DSCR_CAPACITY_TITLE: "Capacity at target",
      DSCR_CAPACITY_SUBTITLE: "Theoretical annual debt service the EBITDA supports at the target ratio; not a loan amount",
      DSCR_CAPACITY_MAX_SERVICE: "Max annual debt service",
      DSCR_CAPACITY_MAX_PRINCIPAL: "Max annual principal (after current interest)",
      DSCR_CAPACITY_UNAVAILABLE: "Capacity needs a positive EBITDA",
      DSCR_DOCUMENTS_TITLE: "Documents used",
      DSCR_DOC_INCOME: "Income statement",
      DSCR_DOC_CASH_FLOW: "Cash flow statement",
      DSCR_DOC_MISSING: "not analyzed",
      DSCR_DOC_CONFIDENCE: "confidence",
      DSCR_HISTORY_TITLE: "History",
      DSCR_HISTORY_SUBTITLE: "Every period where both statements were analyzed",
      DSCR_COL_PERIOD: "Period",
      DSCR_COL_STATUS: "Status",
      DSCR_COL_DSCR: "DSCR",
      DSCR_NOTE_CALCULATION: "Historical, EBITDA-based coverage computed from the stored analyses; nothing is estimated beyond what the documents print.",

      // Income Statement Comparison Component
      INCOME_STATEMENT_BACK: "Back to income statement",
      INCOME_STATEMENT_GENERATING_COMPARISON_TITLE: "Generating Comparison Report",
      INCOME_STATEMENT_ANALYZING_CHANGES: "Analyzing changes between the two income statements...",
      INCOME_STATEMENT_COMPARISON_FAILED: "Failed to generate the comparison. Please try again.",
      INCOME_STATEMENT_PERIODS_NOT_COMPARABLE: "The two periods have different lengths; absolute changes are not directly comparable, only margins are.",
      INCOME_STATEMENT_TREND_IMPROVING: "Improving",
      INCOME_STATEMENT_TREND_DETERIORATING: "Deteriorating",
      INCOME_STATEMENT_TREND_STABLE: "Stable",
      INCOME_STATEMENT_PERIOD_OVER_PERIOD: "Period over period",
      INCOME_STATEMENT_PERIOD_OVER_PERIOD_SUBTITLE: "Each metric is scaled to its own largest value, so bars are comparable within a metric but not across them",
      INCOME_STATEMENT_WHERE_MARGINS_MOVED: "Where margins moved",
      INCOME_STATEMENT_WHERE_MARGINS_MOVED_SUBTITLE: "Share of revenue kept at each level",
      INCOME_STATEMENT_TRIGGERED_FLAGS: "Triggered flags",
      INCOME_STATEMENT_TAKEAWAY_ANALYSIS: "Takeaway analysis",
      INCOME_STATEMENT_NO_COMPARISON_DATA: "No comparison data available for these two periods.",
      INCOME_STATEMENT_UNCHANGED: "Unchanged",

      // Income Statement report layout
      INCOME_STATEMENT_CHIP_DOCUMENT: "Income statement",
      INCOME_STATEMENT_CHIP_USD: "USD",
      INCOME_STATEMENT_CHIP_CHECKS_PASSED: "All extraction checks passed",
      INCOME_STATEMENT_CHIP_INCOMPLETE: "Incomplete statement",
      INCOME_STATEMENT_CONFIDENCE: "Confidence",
      INCOME_STATEMENT_CHECK_NOT_VERIFIED: "derived, not verified against the statement",
      INCOME_STATEMENT_CHIP_WARNINGS_SUFFIX: "extraction warnings",
      INCOME_STATEMENT_CHIP_WARNING_SUFFIX: "extraction warning",
      INCOME_STATEMENT_CHIP_UNVERIFIED_SUFFIX: "figures not verified automatically",
      INCOME_STATEMENT_CHIP_UNVERIFIED_SINGULAR: "figure not verified automatically",
      INCOME_STATEMENT_FINANCIAL_HEALTH: "Financial health",
      INCOME_STATEMENT_TIER_HEALTHY: "Healthy",
      INCOME_STATEMENT_TIER_WATCH: "Watch",
      INCOME_STATEMENT_TIER_AT_RISK: "At risk",
      INCOME_STATEMENT_KEY_INDICATORS: "Key indicators",
      INCOME_STATEMENT_KPI_REVENUE: "Revenue",
      INCOME_STATEMENT_KPI_MARGIN: "margin",
      INCOME_STATEMENT_KPI_NET_MARGIN_SUB: "net margin after interest, taxes and other items",
      INCOME_STATEMENT_KPI_COVERAGE_SUB: "Operating income ÷ interest expense of",
      INCOME_STATEMENT_KPI_VS_PREVIOUS: "vs previous period",
      INCOME_STATEMENT_KPI_UP_FROM: "Up from",
      INCOME_STATEMENT_KPI_DOWN_FROM: "Down from",
      INCOME_STATEMENT_KPI_UNCHANGED: "Unchanged",
      INCOME_STATEMENT_COST_STRUCTURE: "Cost structure",
      INCOME_STATEMENT_COST_STRUCTURE_SUBTITLE_SUFFIX: "of revenue",
      INCOME_STATEMENT_COST_COLUMN_ITEM: "Cost",
      INCOME_STATEMENT_COST_COLUMN_TYPE: "Type",
      INCOME_STATEMENT_COST_COLUMN_MONTHLY: "Monthly",
      INCOME_STATEMENT_COST_MONTHLY_FORMULA_EXACT: "Period total ÷ months in the period:",
      INCOME_STATEMENT_COST_MONTHLY_FORMULA_DAYS: "Partial period: period total ÷ (days ÷ 30.44)",
      INCOME_STATEMENT_COST_COLUMN_ANNUAL: "Period",
      INCOME_STATEMENT_COST_COLUMN_PCT: "% Rev",
      INCOME_STATEMENT_COST_TOTAL: "Total costs and deductions",
      INCOME_STATEMENT_COST_TYPE_DIRECT: "Direct",
      INCOME_STATEMENT_COST_TYPE_OPERATING: "Operating",
      INCOME_STATEMENT_COST_TYPE_DEBT: "Debt",
      INCOME_STATEMENT_COST_TYPE_OTHER: "Other",
      INCOME_STATEMENT_COST_INTEREST: "Interest expense",
      INCOME_STATEMENT_COST_TAXES_OTHER: "Taxes and other non-operating items",
      INCOME_STATEMENT_COST_DA_NOTE: "Depreciation and amortization reported:",
      INCOME_STATEMENT_COST_TYPE_INCOME: "Income",
      INCOME_STATEMENT_COST_DA: "Depreciation and amortization",
      INCOME_STATEMENT_COST_OTHER_EXPENSE: "Other expense",
      INCOME_STATEMENT_COST_INCOME_TAX: "Income tax",
      INCOME_STATEMENT_COST_OTHER_INCOME: "Other income",
      INCOME_STATEMENT_COST_INTEREST_INCOME: "Interest income",
      INCOME_STATEMENT_STATEMENT_REPORTS: "statement reports",
      INCOME_STATEMENT_NORMALIZATIONS_TITLE: "Normalizations applied by the analysis",
      INCOME_STATEMENT_CHECK_TOLERANCE: "tolerance ±",
      INCOME_STATEMENT_ANALYSIS_TITLE: "Analysis",
      INCOME_STATEMENT_ANALYSIS_SUBTITLE: "Written by the model from the verified figures",
      INCOME_STATEMENT_NO_ANALYSIS: "The model did not add observations for this period.",
      INCOME_STATEMENT_OBSERVATIONS: "Observations",
      INCOME_STATEMENT_SEVERITY_OBSERVATION: "Observation",
      INCOME_STATEMENT_SEVERITY_CONCERN: "Concern",
      INCOME_STATEMENT_SEVERITY_POSITIVE: "Positive",
      INCOME_STATEMENT_CHECKS_TITLE: "Checks",
      INCOME_STATEMENT_CHECK_DERIVED_SUFFIX: "(derived)",
      INCOME_STATEMENT_CHECK_GROSS: "Revenue − cost of goods sold = gross profit",
      INCOME_STATEMENT_CHECK_OPERATING: "Gross profit − operating expenses = operating income",
      INCOME_STATEMENT_CHECK_OPERATING_NO_COGS: "Revenue − operating expenses = operating income",
      INCOME_STATEMENT_CHECK_EBITDA: "Operating income + depreciation and amortization = EBITDA",
      INCOME_STATEMENT_CHECK_MARGINS: "Margins match the reported amounts",
      INCOME_STATEMENT_CHECK_COVERAGE: "Interest coverage matches operating income ÷ interest",
      INCOME_STATEMENT_CHECK_MISSING: "Figures not reported on the statement:",
      INCOME_STATEMENT_CHECK_UNVERIFIED_PREFIX: "Not verified automatically:",

      // Taxes Component (TaxRock)
      TAXES_TIN: "TIN",
      TAXES_FORM: "form",
      TAXES_BALANCE_DUE: "Balance due",
      TAXES_SECURED_BY_LIENS: "Secured by liens",
      TAXES_NOT_COVERED_BY_IA: "Not covered by an IA",
      TAXES_MISSING_RETURNS: "Missing returns",
      TAXES_BALANCE_BY_YEAR: "Balance by year",
      TAXES_FORM_LABEL: "Form",
      TAXES_PERIOD: "period",
      TAXES_DUE: "DUE",
      TAXES_PRINCIPAL: "PRINCIPAL",
      TAXES_INTEREST: "INTEREST",
      TAXES_PENALTIES: "PENALTIES",
      TAXES_CREDITS: "CREDITS",
      TAXES_FORM_PERIOD: "FORM · PERIOD",
      TAXES_LIENS: "Liens",
      TAXES_INSTALLMENT_AGREEMENTS: "Installment agreements",
      TAXES_STATUS: "Status",
      TAXES_FILING_DATE: "Filing date",
      TAXES_SECURED_BALANCE: "Secured balance",
      TAXES_SECURED_PERIOD: "Secured period",
      TAXES_SECURED_PERIODS: "Secured periods",
      TAXES_REMOVED: "Removed",
      TAXES_NOT_REMOVED: "Not removed",
      TAXES_BALANCE_AT_REMOVAL: "Balance at removal",
      TAXES_START_DATE: "Start date",
      TAXES_END_DATE: "End date",
      TAXES_CURRENT_BALANCE: "Current balance",
      TAXES_TOTAL_PAID: "Total paid",
      TAXES_BALANCE_AT_CLOSE: "Balance at close",
      TAXES_COVERED_PERIOD: "Covered period",
      TAXES_COVERED_PERIODS: "Covered periods",
      TAXES_EMPTY_TITLE: "No tax report yet",
      TAXES_EMPTY_MESSAGE: "Run a TaxRock report on the business EIN to see its IRS compliance status, balance due, tax liens and installment agreements.",
      TAXES_BUSINESS_EIN: "Business EIN",
      TAXES_DEMO_EINS: "Demo EINs:",
      TAXES_SAVED_REPORTS: "Saved reports",
      TAXES_SAVED_SUFFIX: "saved",
      TAXES_DISCARD_REPORT: "Discard report",
      TAXES_DISCARD: "Discard",
      TAXES_DISCARD_TITLE: "Discard tax report",
      TAXES_DISCARD_BODY: "Discard the saved tax report for",
      TAXES_DISCARD_SUBTEXT: "This can't be undone, and the credit used for the pull isn't refunded.",
      TAXES_DISCARDED: "Tax report discarded.",
      TAXES_DISCARD_FAILED: "Couldn't discard the tax report. Please try again.",
      TAXES_EIN_FROM_BUSINESS: "Prefilled from the business details.",
      TAXES_EIN_NOT_ON_BUSINESS: "Not on the business details. You can add it once TaxRock matches it.",

      // Taxes statuses
      TAXES_STATUS_COMPLIANT: "Compliant",
      TAXES_STATUS_ACTIVE_RESOLUTION: "Active resolution",
      TAXES_STATUS_AT_RISK: "At risk",
      TAXES_STATUS_NOT_COMPLIANT: "Not compliant",
      TAXES_STATUS_DATA_PENDING: "Data pending",

      // Taxes derived copy
      TAXES_PENDING_TILE: "Pending",
      TAXES_NOTHING_RETURNED: "Nothing returned yet.",
      TAXES_FILED_AND_PAID_THROUGH: "Filed and paid through",
      TAXES_NO_BALANCE_NO_LIENS: "No balance, no liens, no missing returns.",
      TAXES_ALL_CLEAR_HEADLINE: "No balance due, no active liens, and no missing returns.",
      TAXES_OWED: "owed",
      TAXES_OWED_ON: "owed on",
      TAXES_WITH_NO_PAYMENT_PLAN: "with no payment plan",
      TAXES_NO_LIEN_FILED_YET: "No lien filed yet.",
      TAXES_FULLY_COVERED: "fully covered by an installment agreement in good standing",
      TAXES_SECURED_BY_LIEN_FILED: "secured by an active lien filed",
      TAXES_RETURN_STILL_MISSING: "return still missing",
      TAXES_RETURNS_STILL_MISSING: "returns still missing",
      TAXES_NONE_COVERED_BY_IA: "none of it covered by an installment agreement",
      TAXES_OUTSIDE_ANY_PLAN: "of it outside any payment plan",
      TAXES_COVERED_BY_IA_STARTED: "covered by an active installment agreement started",
      TAXES_AND: "and",
      TAXES_PRINCIPAL_INLINE: "Principal",
      TAXES_INTEREST_INLINE: "interest",
      TAXES_PENALTIES_INLINE: "penalties",
      TAXES_CREDITS_INLINE: "credits",
      TAXES_NO_CREDITS_APPLIED: "no credits applied",
      TAXES_SETTLED: "settled",
      TAXES_ACTIVE_LIEN_FILED: "active lien filed",
      TAXES_ACTIVE_LIENS_MOST_RECENT: "active liens, most recent filed",
      TAXES_SECURING: "securing",
      TAXES_AGAINST_FORM: "against form",
      TAXES_TAX_YEAR: "tax year",
      TAXES_NO_IA_LEAD: "No installment agreement.",
      TAXES_NO_IA_UNCOVERED_ON: "uncovered on form",
      TAXES_NO_IA_PREFIX: "No installment agreement. The full",
      TAXES_NO_IA_SUFFIX: "sits outside any payment plan.",
      TAXES_NO_IA_NONE_NEEDED: "No installment agreement. None needed: nothing is owed.",
      TAXES_IA_AGREEMENT_SINCE: "agreement since",
      TAXES_IA_AGREEMENT_STARTED: "agreement started",
      TAXES_IA_PAID: "paid",
      TAXES_IA_REMAINING: "remaining",
      TAXES_IA_OUTSIDE_PLAN: "sits outside the plan.",

      // Taxes actions and states
      TAXES_RUN_REPORT: "Run tax report",
      TAXES_RE_PULL: "Re-pull",
      TAXES_PULLING: "Pulling...",
      TAXES_PULLED: "Pulled",
      TAXES_PULL_SUCCESS: "Tax report pulled.",
      TAXES_PULL_FAILED: "Couldn't pull the tax report. Please try again.",
      TAXES_PULL_EMPTY: "TaxRock returned no data for this EIN.",
      TAXES_RECONNECT_REQUIRED: "The TaxRock connection has expired. Reconnect the account in settings, then pull again.",
      TAXES_EIN_PLACEHOLDER: "9-digit EIN",
      TAXES_EIN_INVALID: "EIN must be 9 digits.",
      TAXES_EIN_MATCHED_PREFIX: "TaxRock matched",
      TAXES_EIN_ADD_PROMPT: "It isn't on the business details yet.",
      TAXES_EIN_REPLACE_PROMPT: "It differs from the one on the business details",
      TAXES_EIN_ADD_BUTTON: "Add to business",
      TAXES_EIN_REPLACE_BUTTON: "Update business EIN",
      TAXES_EIN_SAVED: "EIN saved to the business details.",
      TAXES_EIN_SAVE_FAILED: "Couldn't save the EIN to the business. Please try again.",
      TAXES_SNAPSHOT_UNREADABLE: "This record's saved snapshot could not be read.",
      TAXES_STATUS_NOT_MONITORED: "Not monitored",
      TAXES_NOT_MONITORED_MESSAGE: "TaxRock has no taxpayer matching this EIN, so there is nothing to report yet.",
      TAXES_EIN: "EIN",

      // Taxes UI (redesign)
      TAXES_TITLE: "Taxes",
      TAXES_PROVIDER: "taxRock",
      TAXES_PULLED_PREFIX: "pulled",
      TAXES_WHY_THIS_MATTERS: "Why this matters:",
      TAXES_OUTSIDE_A_PAYMENT_PLAN: "Outside a payment plan",
      TAXES_ACTIVE_SUFFIX: "ACTIVE",
      TAXES_PENDING_PILL: "PENDING",
      TAXES_VIEW_FILING_DETAIL: "View filing detail",
      TAXES_VIEW_AGREEMENT_DETAIL: "View agreement detail",
      TAXES_HIDE_FILING_DETAIL: "Hide filing detail",
      TAXES_HIDE_AGREEMENT_DETAIL: "Hide agreement detail",
      TAXES_NO_YEARS_TITLE: "No transcript years returned yet",
      TAXES_NO_YEARS_BODY: "taxRock has the filer on file and the transcripts are still in flight. This section fills in on a later pull.",

      // Taxes tile sub-notes
      TAXES_NOTE_NOTHING_OWED: "nothing owed",
      TAXES_NOTE_ACROSS_ONE_YEAR: "across 1 tax year",
      TAXES_NOTE_ACROSS_YEARS_PREFIX: "across",
      TAXES_NOTE_ACROSS_YEARS_SUFFIX: "tax years",
      TAXES_NOTE_TRANSCRIPTS_IN_FLIGHT: "transcripts in flight",
      TAXES_NOTE_NOT_RETURNED: "not returned",
      TAXES_NOTE_NO_FILINGS: "no filings",
      TAXES_NOTE_ONE_ACTIVE_FILING: "1 active filing",
      TAXES_NOTE_ACTIVE_FILINGS_SUFFIX: "active filings",
      TAXES_NOTE_INSIDE_AN_AGREEMENT: "inside an agreement",
      TAXES_NOTE_NO_AGREEMENT_IN_PLACE: "no agreement in place",
      TAXES_NOTE_ALL_YEARS_FILED: "all years filed",
      TAXES_NOTE_RETURN_NOT_FILED: "return not filed",
      TAXES_NOTE_RETURNS_NOT_FILED: "returns not filed",

      // Taxes "why this matters" copy
      TAXES_WHY_COMPLIANT_PREFIX: "filed years, every balance cleared by credits. Nothing here caps the line.",
      TAXES_WHY_NOT_COMPLIANT_LIEN: "The IRS holds a claim on the same receivables you would advance against",
      TAXES_WHY_NOT_COMPLIANT_BALANCE: "An unpaid balance of this size is one filing away from an IRS claim on your collateral",
      TAXES_WHY_NOT_COMPLIANT_MISSING_ONE: "and 1 return is still missing",
      TAXES_WHY_NOT_COMPLIANT_MISSING_MANY: "returns are still missing",
      TAXES_WHY_NOT_COMPLIANT_ACTION: "Recommended action: decline, or require a filed return and an active agreement before funding.",
      TAXES_WHY_NOT_COMPLIANT_ACTION_NO_MISSING: "Recommended action: decline, or require an active agreement before funding.",
      TAXES_WHY_AT_RISK: "An uncovered balance with no plan is the state a lien is filed from, and a filing would sit ahead of your position. Recommended action: cap the advance rate at 80% and re-check taxes in 30 days.",
      TAXES_WHY_ACTIVE_RESOLUTION: "The full balance is inside a plan in good standing, so no lien is expected while payments hold. Recommended action: fund, and re-pull taxes before later advances to confirm payments are current.",
      TAXES_WHY_DATA_PENDING: "An unknown is not a clean report. Recommended action: hold the tax condition open until the transcripts land.",
      TAXES_WHY_NOT_MONITORED: "No transcripts exist for this EIN, so the tax position is unverified. Recommended action: confirm the EIN before relying on this report.",

      // Taxes derived copy (redesign wording)
      TAXES_PENDING_HEADLINE_NEW: "taxRock is still retrieving transcripts. This filer cannot be scored yet.",
      TAXES_OWED_ON_TAX_YEAR: "owed on tax year",
      TAXES_OWED_ON_TAX_YEARS: "owed on tax years",
      TAXES_WITH_NO_PAYMENT_PLAN_CLAUSE: "with no payment plan",
      TAXES_AND_NO_LIEN_YET: "and no lien filed yet",
      TAXES_NO_LIENS_ON_FILE: "No liens on file.",
      TAXES_NO_LIENS_ON_FILE_DRAW: "No liens on file. A balance this size can draw one.",
      TAXES_NO_LIENS_ON_FILE_EVER: "No liens on file, active or released.",
      TAXES_NOT_REMOVED_SENTENCE: "Not removed.",
      TAXES_REMOVED_ON: "Removed",
      TAXES_NO_IA_ON_FILE_NONE_NEEDED: "No installment agreement on file. None is needed: nothing is owed.",
      TAXES_IA_ACTIVE_SINCE_PREFIX: "Active agreement since",
      TAXES_IA_PAID_REMAINING: "paid",
      TAXES_IA_REMAINING_COVERING: "remaining, covering form",
      TAXES_IA_SETTLED_SUFFIX: "Settled.",
      TAXES_NO_CREDITS_APPLIED_SENTENCE: "No credits applied.",

      // Analysis Workspace Component

    MARKETPLACE: {
      TITLE: "Marketplace Features",
      ADMIN_ONLY: "Admin Only",
      OPT_IN_TITLE: "Opt-in to Buy New Applications",
      OPT_IN_DESCRIPTION: "Enabling this allows your organization to purchase new application leads from the marketplace. This will incur additional costs per application.",
      OPT_OUT_TITLE: "Opt-out of Sharing Declined Applications", 
      OPT_OUT_DESCRIPTION: "Disabling this shares your organization's declined applications with the marketplace. This can generate revenue share.",
      
      CONFIRMATION_ENABLE_BUYING_TITLE: "Enable Marketplace Buying?",
      CONFIRMATION_ENABLE_BUYING_MESSAGE: "This will allow your organization to purchase new application leads from the marketplace. Additional costs will apply per application.",
      CONFIRMATION_DISABLE_BUYING_TITLE: "Disable Marketplace Buying?",
      CONFIRMATION_DISABLE_BUYING_MESSAGE: "This will disable your organization from purchasing new application leads from the marketplace.",
      CONFIRMATION_STOP_SHARING_TITLE: "Stop Sharing Declined Applications?",
      CONFIRMATION_STOP_SHARING_MESSAGE: "This will stop sharing your declined applications with the marketplace and you will no longer receive revenue share.",
      CONFIRMATION_ENABLE_SHARING_TITLE: "Enable Sharing Declined Applications?",
      CONFIRMATION_ENABLE_SHARING_MESSAGE: "This will share your declined applications with the marketplace and you may receive revenue share.",
      
      GENERAL_CRITERIA: "Configure General Marketplace Criteria",
      FMCSA_CRITERIA: "Configure FMCSA Safety Criteria", 
      SOS_CRITERIA: "Configure SOS Safety Criteria",
      UCC_CRITERIA: "Configure UCC Criteria",
      BACKGROUND_CRITERIA: "Configure Background Check Criteria",
      
      ENABLE: "Enable",
      SAVE_ALL: "Save All Marketplace Criteria",
      SAVING: "Saving...",
      
      SUCCESS_MESSAGE: "Marketplace criteria saved successfully",
      ERROR_MESSAGE: "Error saving marketplace criteria", 
      FAILED_MESSAGE: "Failed to save marketplace criteria. Please try again.",
      FLAG_SUCCESS: "Feature flag updated successfully",
      FLAG_ERROR: "Failed to update feature flag. Please try again.",
      
      WARNING_MESSAGE: "Changes to these settings affect all administrators and may impact data sharing and platform costs. Please review carefully.",
      
      SOS_CONFIGURATION: "SOS Safety Configuration",
      EXCLUDE_INACTIVE_BUSINESSES: "Exclude Inactive Businesses",
      EXCLUDE_UNKNOWN_STATUS: "Exclude Unknown Status", 
      EXCLUDE_INACTIVE_HELP: "Exclude businesses with inactive SOS status",
      EXCLUDE_UNKNOWN_HELP: "Exclude businesses with unknown SOS status",
      
      UCC_CONFIGURATION: "UCC Lien Configuration",
      MAXIMUM_ACTIVE_LIENS: "Maximum Active Liens",
      MAX_LIENS_HELP: "Maximum number of active liens allowed",
      EXCLUDED_SECURED_PARTIES: "Excluded Secured Parties",
      SECURED_PARTIES_PLACEHOLDER: "Enter secured party names",
      
      BACKGROUND_CONFIGURATION: "Background Check Configuration", 
      CRIMINAL_RECORDS: "Criminal Records",
      REQUIRE_CLEAN_CRIMINAL: "Require Clean Criminal Record",
      LOOK_BACK_YEARS: "Look Back Years",
      EXCLUDED_CASE_TYPES: "Excluded Case Types",
      EXCLUDED_DISPOSITIONS: "Excluded Dispositions",
      CASE_TYPES_PLACEHOLDER: "e.g. Felony, Misdemeanor",
      DISPOSITIONS_PLACEHOLDER: "e.g. Guilty, Convicted",
      
      LIENS_JUDGMENTS: "Liens and Judgments", 
      REQUIRE_CLEAN_LIENS: "Require Clean Liens and Judgments",
      MAXIMUM_FILING_QUANTITY: "Maximum Filing Quantity",
      EXCLUDED_FILING_TYPES: "Excluded Filing Types",
      FILING_TYPES_PLACEHOLDER: "e.g. CIVIL JUDGMENT",
      
      BANKRUPTCIES: "Bankruptcies",
      REQUIRE_CLEAN_BANKRUPTCIES: "Require Clean Bankruptcies", 
      EXCLUDED_CHAPTERS: "Excluded Chapters",
      CHAPTERS_PLACEHOLDER: "e.g. 7, 11, 13",
      BANKRUPTCIES_DISPOSITIONS_PLACEHOLDER: "e.g. Open, Discharged",
      
      CANCEL: "Cancel",
      CONFIRM: "Confirm", 
      UPDATING: "Updating..."
    },
    UD: {
      DATE_LABEL: '{date} · {time}',
      GREETING_MORNING: 'Good morning,',
      GREETING_AFTERNOON: 'Good afternoon,',
      GREETING_EVENING: 'Good evening,',
      GREETING_SUBTITLE: "You're on pace for the month.",
      GREETING_APPS_WAITING: '{pending} applications',
      GREETING_APPS_WAITING_SUFFIX: 'are waiting on you, with',
      GREETING_CHECKS: '{checks} checks',
      GREETING_CHECKS_SUFFIX: 'still to clear.',
      TIME_TAB_TODAY: 'Today',
      TIME_TAB_WEEK: 'This week',
      TIME_TAB_MONTH: 'This month',
      APPLICATIONS_DECISIONED_TODAY: 'Applications Decisioned · Today',
      APPLICATIONS_DECISIONED_WEEK: 'Applications Decisioned · This Week',
      APPLICATIONS_DECISIONED_MONTH: 'Applications Decisioned · This Month',
      GOAL_LABEL: '/ {goal} within SLA',
      NO_GOAL_SET: 'No weekly goal set',
      APPROVED_DECLINED: 'Approved {approved}. Declined {declined}.',
      CANCELLED: 'Cancelled {cancelled}.',
      PENDING_MORE: '{remaining} more pending to clear.',
      BACKLOG_CLEARED: 'Nothing pending — backlog cleared.',
      ALL_PENDING_CLEARED: 'All pending cleared!',
      SLA_MISSED: '{missed} missed target (>{slaHours}h).',
      SLA_ALL_WITHIN: 'All decisions within {slaHours}h.',
      SLA_NO_DECISIONS_YET: 'No decisions yet in this range.',
      NO_DECISIONS_YET: 'No decisions yet',
      VS_LAST: '{sign}{delta} vs. last',
      ALL_CLEAR: 'All clear',
      TARGET_MET: 'Target met',
      ON_PACE: 'On pace',
      DECISION_STREAK: 'Decision Streak',
      DAY: 'day',
      DAYS: 'days',
      STREAK_ACTIVE: '{days} straight working {dayLabel} closing at least one application. Keep it going.',
      NO_ACTIVE_STREAK: 'No active streak yet. Decide on an application today to start one.',
      PENDING_APPLICATIONS: 'Pending applications · {count}',
      STUCK_OVER_24H: '{count} stuck > 24h',
      SORTED_BY_OLDEST: 'Sorted by oldest',
      NO_PENDING_APPLICATIONS: 'No pending applications in this range.',
      UNNAMED_APPLICATION: 'Unnamed application',
      APP_META: '{type}',
      NO_CHECKS_YET: 'No checks yet',
      CHECKS_OF: '{completed} of {total} checks',
      OPEN: 'Open',
      TODAY_AGENDA: "Today's agenda",
      NOTHING_PENDING: 'Nothing is waiting on you.',
      AVG_CYCLE_TIME: 'Avg cycle time',
      HRS: 'hrs',
      FROM_NEW_TO_DECISION: 'From new → decision',
      CHECKS_COMPLETED: 'Checks completed',
      THIS_RANGE: 'this {range}',
      ACROSS_APPLICATIONS: 'Across {count} applications',
      CHECKS_PENDING: 'Checks pending',
      ACROSS_APPS: 'across {count} apps',
      STAT_STUCK: '{count} stuck > 24h',
      HOW_TEAM_TRACKING: 'How the team is tracking · this month',
      DECISIONS_CYCLE_TIME: 'Decisions · cycle time',
      NO_TEAM_ACTIVITY: 'No team activity this month yet.',
      RANK_LABEL: 'RANK · 0{rank}',
      RANK_YOU: '· YOU',
      UNDERWRITER: 'UNDERWRITER',
      DECISIONED: 'Decisioned',
      CYCLE: 'Cycle',
      WEEKLY_TARGET: 'WITHIN SLA',
      NO_DATA: 'No data',
    },
    UD_SETTINGS: {
      TITLE: 'Underwriting SLA',
      DESCRIPTION: 'Set the expected time within which an application should be approved or declined. The Activity Dashboard uses this value to track on-time decisions.',
      SLA_LABEL: 'Expected decision time (hours)',
      SAVE: 'Save',
      SAVE_SUCCESS: 'Underwriting settings saved.',
      SAVE_ERROR: 'Could not save underwriting settings.',
      SLA_INVALID: 'Enter a positive number of hours.',
    },
    CT: {
      TAB_LABEL: 'Tasks',
      HEADING: 'Collaborative Tasks',
      SUMMARY: '{open} open · {completed} completed · {external} with external user',
      NEW_TASK: '+ NEW TASK',
      FILTER_OPEN: 'Open',
      FILTER_ALL: 'All',
      FILTER_COMPLETED: 'Completed',
      SORT_LABEL: 'Sort:',
      SORT_MOST_RECENT: 'Most recent',
      EMPTY_LIST: 'No tasks yet. Click + NEW TASK to create one.',
      EMPTY_FILTERED: 'No tasks match this filter.',
      STATUS_ASSIGNED: 'ASSIGNED',
      STATUS_REJECTED: 'REJECTED',
      STATUS_COMPLETED: 'COMPLETED',
      ASSIGNED_TO: 'assigned to',
      UNASSIGNED: 'unassigned',
      BY: 'by',
      EXT_BADGE: 'EXT',
      EXT_WARNING: "This email is not in Rox. The notification will be delivered via Salesforce. The recipient won't see Rox.",
      // Modal — create
      MODAL_NEW_TITLE: 'New Collaborative Task',
      FIELD_TITLE: 'Title',
      FIELD_TITLE_PLACEHOLDER: 'Short, specific action',
      FIELD_DESCRIPTION: 'Description (optional)',
      FIELD_DESCRIPTION_PLACEHOLDER: 'Context for the assignee',
      FIELD_ASSIGN_TO: 'Assign to',
      FIELD_ASSIGN_TO_PLACEHOLDER: 'name@company.com',
      SUGGESTIONS_HEADER: 'Suggestions from directory',
      FOOTER_NOTIFICATION_HINT: 'A notification will be sent on create.',
      ACTION_CANCEL: 'Cancel',
      ACTION_CREATE: 'Create & assign',
      ACTION_OPEN: 'Open',
      // Modal — reject
      MODAL_REJECT_TITLE: 'Reject task',
      FIELD_REASON: 'Reason',
      FIELD_REASON_PLACEHOLDER: 'Why are you rejecting this task?',
      ACTION_REJECT: 'Reject',
      // Modal — reassign
      MODAL_REASSIGN_TITLE: 'Reassign task',
      CURRENT_ASSIGNEE: 'Current assignee',
      ACTION_REASSIGN: 'Reassign',
      // Modal — complete
      MODAL_COMPLETE_TITLE: 'Complete task',
      FIELD_NOTES: 'Notes (optional)',
      FIELD_NOTES_PLACEHOLDER: 'Anything useful to record',
      ACTION_COMPLETE: 'Complete',
      // Drawer
      DRAWER_ASSIGNEE: 'Assignee',
      DRAWER_ASSIGNER: 'Assigner',
      DRAWER_CREATED: 'Created',
      DRAWER_LAST_UPDATE: 'Last update',
      DRAWER_DESCRIPTION: 'Description',
      DRAWER_TIMELINE: 'Timeline',
      EVENT_CREATED: 'CREATED',
      EVENT_ASSIGNED: 'ASSIGNED',
      EVENT_REJECTED: 'REJECTED',
      EVENT_COMPLETED: 'COMPLETED',
      // Validation
      REQUIRED_TITLE: 'Title is required.',
      REQUIRED_ASSIGNEE: 'Assignee email is required.',
      INVALID_EMAIL: 'Enter a valid email address.',
      REQUIRED_REASON: 'A rejection reason is required.',
      // Toasts
      CREATED_OK: 'Task created.',
      CREATED_ERR: 'Could not create task.',
      REJECTED_OK: 'Task rejected.',
      REJECTED_ERR: 'Could not reject task.',
      COMPLETED_OK: 'Task completed.',
      COMPLETED_ERR: 'Could not complete task.',
      REASSIGNED_OK: 'Task reassigned.',
      REASSIGNED_ERR: 'Could not reassign task.',
    },
    CT_BELL: {
      TITLE: 'Notifications',
      NOTIFICATION_SETTINGS: 'Notification settings',
      MARK_ALL_READ: 'MARK ALL READ',
      FOOTER_TOTAL: '{total} total',
      VIEW_ALL: 'VIEW ALL IN TASKS TAB',
      EMPTY: 'No notifications yet.',
      EVENT_ASSIGNED: 'assigned',
      EVENT_REJECTED: 'rejected',
      EVENT_COMPLETED: 'completed',
    }
  }
})

export const addStrings = (obj, lang = 'en') => {
  const original = strings.getContent()[lang]
  strings.setContent({
    [lang]: mergeDeep(original, obj)
  })
  return strings
}

function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

function mergeDeep(source, target) {
  let output = Object.assign({}, target)
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) Object.assign(output, {
          [key]: source[key]
        })
        else output[key] = mergeDeep(target[key], source[key])
      } else {
        Object.assign(output, {
          [key]: source[key]
        })
      }
    })
  }
  return output
}

export default strings
